import { AccessTime, CalendarToday, Print, Search as SearchIcon } from '@mui/icons-material';
import { Permissions, useScopeChecker } from 'src/rbac';
import {
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Radio,
  SvgIcon,
  Tab,
  Table,
  TableBody,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import moment from 'moment';
import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { BootstrapDialog } from 'src/components/common-modals/BootstrapDialog';
import DeletePopupModal, {
  default as ConfirmationPopupModal,
} from 'src/components/common-modals/delete-modal';
import InfoModal from 'src/components/common-modals/info-modal';
import { Seo } from 'src/components/seo';
import SucessModal from 'src/components/sucess-modal';
import useCurrentUser from 'src/hooks/use-current-user';
import { useSettings } from 'src/hooks/use-settings';
import { BasicDateCalendar } from 'src/layouts/components/CustomDatePicker';
import SimpleSnackbar from 'src/pages/details-page/sub-components/snackBar';
import { permissions } from 'src/paths';
import { useAddAnnouncementGate } from '../use-add-announcement-gate';
import { resetEditTaskTimeAction } from 'src/redux/actions/editTaskTimeAction';
import {
  getAllTherapistTaskAction,
  updateTimeBasisAction,
} from 'src/redux/actions/getAllTherapistAction';
import { scheduleRecurringAppointmentResetAction } from 'src/redux/actions/appointmentAction';
import {
  GET_PATIENT_RECORD,
  getEnterprisePayerPlanType,
  getSingleTherapistAction,
} from 'src/redux/actions/patientAction';
import { reassignTherapistTaskAction } from 'src/redux/actions/rearrangeTherapistTaskAction';
import {
  deleteAnnouncementAction,
  getAllAnnouncementsAction,
  resetDeleteAnnouncementAction,
  resetGetAllAnnouncementsAction,
} from 'src/redux/actions/schedularAnnouncementsAction';
import {
  deleteSplitTaskAction,
  editResetSplitTaskMinAction,
  getAllMaintainedTherapistAction,
  getSplitTaskAction,
  getSplitTaskMinAction,
  maintainTherapistFilterAction,
  resetAllMaintainedTherapistAction,
  resetDeleteSplitTaskAction,
  resetSplitTaskMinAction,
} from 'src/redux/actions/schedularTherapistFilterAction';
import {
  editTaskTherapistSchedulingAction,
  editTaskTherapistSchedulingResetAction,
  getAllTaskTypeAction,
  resetAddNewTaskTherapist,
} from 'src/redux/actions/taskTypeAction';
import {
  therapistAssignTaskAction,
  therapistAssignTaskResetAction,
} from 'src/redux/actions/therapistAssignTaskAction';
import { therapistAssignUndoAction } from 'src/redux/actions/therapistAssignmentUndoAction';
import { resetTherapistAssignDataAction } from 'src/redux/actions/therapistDialogAssignTaskAction';
import { getAllTherapistDiciplineAction } from 'src/redux/actions/therapistDiciplineAction';
import {
  getDailyNotesPrintStatus,
  resetDailyNotesPrintStatus,
} from 'src/redux/actions/dailySessionNotes';
import {
  getAllTherapistListAction,
  getAllTherapistListResetAction,
} from 'src/redux/actions/therapistListAction';
import {
  migrateTherapisPatientAction,
  migrateTherapisPatientResetAction,
  therapistMigrateTaskAction,
  therapistMigrateTaskResetAction,
} from 'src/redux/actions/therapistMigrateTaskAction';
import {
  therapistPatientUnAssignAction,
  therapistPatientUnAssignReset,
} from 'src/redux/actions/therapistPatientUnAssignAction';
import {
  autoMatchingTherapistAction,
  autoMatchingTherapistResetAction,
  disableAutoMatchAction,
  getAllDisciplineTherapist,
} from 'src/redux/actions/therapistsAction';
import {
  deletePatientTask,
  deleteTherapistTaskNoteAction,
  getTherapistSkillList,
  resetCreateTherapistTaskNote,
  resetDeletePatientTask,
  resetDeleteTherapistTaskNote,
} from 'src/redux/actions/therapySchedulingSkillList';
import LoaderIcon from '../../../../../src/components/LoaderImg/loader.gif';
import '../../../../global.css';
import AddTaskForm from '../../AddTaskForm/AddTaskForm-1';
import EditTaskTime from '../../EditTaskTime/editTaskTime';
import GroupTherapistTask from '../../GroupTherapistTask/groupTherapistTask';
import RescheduleTaskModal from '../../reschedule-task-modal';
import ScheduleTaskNote from '../../taskNote/schedule-task-note';
import {
  confirmCancelTestIds,
  schedulingTestId,
  taskTestId,
  therapistColumnTestId,
} from '../../test-ids';
import '../TherapistTaskInfo/widgets/therapistStyles.scss';
import Loader from '../loader';
import { MultiSelect } from '../multi-select';
import { MultiSelectPatientList } from '../multiSelectPatientList';
import { SkillsMultiSelect } from '../skills-multi-select';
import AnnouncementDialog from './announcement-dialog';
import PayerColorLegend from './payer-color-lagend';
import Switcher from './ptif-switch';
import { AnnouncementIcon } from './schedule-icon';
import TherapistInfo from './therapist-infoV3';
import TherapistTaskList from './therapist-task-list';
import TaskSplitMin from './task-split-min';
import AppointmentSchedulingModal from './appointment-scheduling-modal';
import BulkSchedulePrintDialog from './BulkSchedulePrintDialog';

interface selectedReSchedulingTaskType {
  uuid?: string;
  localDate?: string;
  tasksType?: string;
  numberOfMinutes?: string;
  description?: string;
  discipline?: string;
  patientUuid?: string;
}

type InitialStateOfInfoModal = {
  message: string;
  type: null | 'SUPERVISION_ALERT';
  title: string;
};

const initialStateOfInfoModal: InitialStateOfInfoModal = {
  message: '',
  type: null,
  title: '',
};

/**
 * THIN-7718: true when a list response was requested for a different discipline than the
 * board currently on screen, and must therefore not be merged into it.
 *
 * Both list fetch watchers are takeEvery (the post-assign refresh deliberately fires
 * pages 1..N concurrently and relies on them all merging into one redux slot), and the
 * mutation sagas re-trigger the task fetch with no abort signal. So responses land in
 * completion order and a request issued before a discipline switch can resolve after the
 * new board's request, putting off-discipline rows into the visible lists.
 *
 * Returns false when either side is missing so that any dispatcher which does not supply
 * a discipline keeps its previous behaviour rather than silently rendering an empty board.
 */
const isDisciplineMismatch = (responseDiscipline: any, boardDiscipline: any): boolean =>
  !!responseDiscipline && !!boardDiscipline && responseDiscipline !== boardDiscipline;

// Only these four task types are offered as filters, in the order the design lays them out.
const TASK_TYPE_FILTERS: { key: string; breakdownKey: string; label: string }[] = [
  { key: 'THERAPY', breakdownKey: 'INDIVIDUAL_THERAPY', label: 'Individual' },
  { key: 'EVALUATION', breakdownKey: 'EVALUATION', label: 'Eval' },
  { key: 'CONCURRENT', breakdownKey: 'CONCURRENT', label: 'Concurrent' },
  { key: 'GROUP_THERAPY', breakdownKey: 'GROUP_THERAPY', label: 'Group' },
];

// 173 -> "2:53"
const formatMinutesAsHours = (minutes: number): string =>
  `${Math.floor((minutes || 0) / 60)}:${String((minutes || 0) % 60).padStart(2, '0')}`;

type TimeBasis = 'LABOR' | 'PATIENT';

const TIME_BASIS_OPTIONS: { value: TimeBasis; label: string }[] = [
  { value: 'LABOR', label: 'Labor Time' },
  { value: 'PATIENT', label: 'Patient Time' },
];

const TIME_BASIS_TOOLTIP: Record<TimeBasis, string> = {
  LABOR: 'Total scheduled therapist minutes —' + ' concurrent counts at 50%, group at 25%.',
  PATIENT:
    'Total scheduled patient minutes across all' +
    'treatment modes (individual, concurrent, group).',
};

const TherapistSchedule = () => {
  const calenderRef = useRef<HTMLDivElement | null>(null);
  const matches = useMediaQuery('(min-width:1653px)');
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data
  );
  const has = useScopeChecker();

  // Segment B: scheduler add-announcement gate migrated to the instrumented scopeKey path.
  // (permissionData still backs the ADD_DAILY_TASK / discipline reads below — out of scope.)
  const canAddAnnouncement = useAddAnnouncementGate();
  const isAutoMatchDisable = useSelector(
    (state: any) => state?.disableAutoMatchReducer?.response?.data
  );
  const autoMatchingTherapistLoading = useSelector(
    (state: any) => state?.autoMatchingThearpistReducer?.loading
  );

  const lgdown = useMediaQuery((theme: any) => theme.breakpoints.down('1371'));
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [currentTab, setCurrentTab] = useState<string>(
    permissionData?.discipline ? permissionData?.discipline : 'PT'
  );
  // THIN-7718: the list merge effects key off the redux response, not off currentTab, so
  // they must read the board that is on screen *now* rather than the one captured when
  // the effect's closure was created. Assigned during render so it is always current
  // without adding currentTab to those effects' dep arrays (which would re-merge an old
  // response on every tab change).
  const currentTabRef = useRef<string>(currentTab);
  currentTabRef.current = currentTab;
  const [currentSkillSelected, setCurrentSkillSelected] = useState<string>('');
  const [patientSearchInput, setPatientSearchInput] = useState<string>('');
  const [patientSearchString, setPatientSearchString] = useState<string>('');
  const [selectedTaskType, setTaskType] = useState<any[]>([]);
  const [selectedSortType] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [openGroupDialog, setOpenGroupDialog] = useState(false);
  const [dragged, setDragged] = useState(false);
  const [draggedId, setDraggedId] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [infoTitle, setInfoTitle] = useState('');
  const [popUpMessage, setPopUpMessage] = useState<{
    message: string;
    type: string;
    hideSuccessIcon?: boolean;
  }>({
    message: '',
    type: '',
    hideSuccessIcon: false,
  });
  const [openAddTaskForm, setOpenAddTaskForm] = useState(false);
  const [openEditTimeDialog, setOpenEditTimeDialog] = useState(false);
  const [sucessFullRequest, setSuccessFullRequest] = useState(false);
  const [isBulkPrintOpen, setIsBulkPrintOpen] = useState(false);
  const [therapyInfo, setTherapyInfo] = useState<any>({
    therapyType: '',
    taskType: '',
    taskId: '',
    numberOfMinutes: 0,
    isAssigned: false,
  });
  const abortControllerRef = useRef<any>();
  const abortControllerPatinetListRef = useRef<any>();
  const reloadUpToPageRef = useRef<number>(0);
  const skipNextTaskFetchRef = useRef(false);
  const [reSchedulingTask, setReSchedulingTask] = useState(false);
  const [reSchedulingTaskDate, setReSchedulingTaskDate] = useState<Date>(new Date());
  const [taskListState, setTasklistState] = useState<any[]>([]);
  const [therapistIdToDrop, setTherapistIdToDrop] = useState('');
  const [patientTaskPageNo, setPatientTaskPageNo] = useState(0);
  const [therapistListPageNo, setTherapistListPageNo] = useState(0);
  const [patientTotalElementsState, setPatientTotalElementsState] = useState(0);
  const [therapistListState, setTherapistListState] = useState<any[]>([]);
  const [showPatientTaskMainLoader, setPatientTaskShowMainLoader] = useState(true);
  // Which basis the header total is read on. Labor Time discounts shared sessions
  // (concurrent 50%, group 25%) because one therapist covers several patients at once;
  // Patient Time counts every mode as written.
  const [timeBasis, setTimeBasis] = useState<'LABOR' | 'PATIENT'>('LABOR');

  // The patients panel is 40% of the content width, floored at 440px, and every 13" laptop
  // lands on that floor. At 440 the time row cannot hold the four "(n)" session counts on one
  // line even with the chrome tightened, and wrapping would push the patient list down. So the
  // counts are the lever: they show only once the panel is wide enough to keep them on one line.
  const PATIENT_PANEL_COUNTS_MIN_WIDTH = 480;
  const patientPanelRef = useRef<HTMLDivElement | null>(null);
  const [isPatientPanelNarrow, setIsPatientPanelNarrow] = useState(false);
  useEffect(() => {
    const panel = patientPanelRef.current;
    if (!panel || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(([entry]) => {
      setIsPatientPanelNarrow(entry.contentRect.width < PATIENT_PANEL_COUNTS_MIN_WIDTH);
    });
    observer.observe(panel);
    return () => observer.disconnect();
  }, []);

  // Debounce the patient search input — only push to the API trigger string after the
  // user pauses typing.
  useEffect(() => {
    const handle = setTimeout(() => {
      const next = patientSearchInput.trim();
      if (next !== patientSearchString) {
        setPatientSearchString(next);
        setPatientTaskShowMainLoader(true);
        setPatientTaskPageNo(0);
        setTasklistState([]);
        setTaskSelectedId([]);
      }
    }, 400);
    return () => clearTimeout(handle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientSearchInput]);
  const [showTherapistTaskMainLoader, setTherapistTaskMainLoader] = useState(true);
  const [closeGroupDialog, setCloseGroupDialog] = useState(true);
  const [deleteModalInfo, setDeleteModalInfo] = useState<any>({
    open: false,
    message: '',
    saveLabel: '',
    closeLabel: '',
    title: '',
    deleteType: '',
  });
  const [currentPatientTask, setCurrentPatientTask] = useState('');
  const [switchState, setSwitchState] = useState<'Productivity Goal' | 'PTIF'>('Productivity Goal');
  // APIT-667: the per-enterprise productivity-targets switch, off the same provider/paycom-status
  // payload that already carries enablePaycom/enablePto. That call is fired by assignFacilitySaga
  // the moment the assigned facilities land, and the reducer is in the redux-persist whitelist,
  // so the value is in the store well before this page mounts.
  //
  // Compared against false on purpose: undefined -- an older service, a failed call, a reducer
  // that has not filled yet -- has to mean enabled, because enabled is what every enterprise does
  // today. Only an explicit false from the API removes the toggle.
  const productivityTargetsEnabled = useSelector(
    (state: any) =>
      state?.thePayComeDetailsReducer?.response?.data?.productivityTargetsEnabled !== false
  );
  const [isMaintainFilterAvailable, setIsMaintainFilterAvailable] = useState(false);
  const [filterTherapistList, setFilterTherapistList] = useState([]);
  const [isStatsRefresh, setIsStatsRefresh] = useState(false);
  const [meta, setMeta] = useState({});
  const [migratePatientData, setMigratePatientData] = useState<any>();
  const [unAssignPatientData, setUnAssignPatientData] = useState<any>({});
  const [selectedReSchedulingTask, setSelectedReSchedulingTask] =
    useState<selectedReSchedulingTaskType>({});
  const [taskSelectedId, setTaskSelectedId] = useState<any>([]);
  const [successModalTitle, setSuccessModalTitle] = useState({
    title: '',
    message: '',
  });
  const [openCalender, setOpenCalender] = useState(false);
  const [noOfTherapistEditDialogOpen, setNoOfTherapistEditDialogOpen] = useState<boolean[]>([]);
  const [updateDailyTasks, setUpdateDailyTasks] = useState(false);
  const [readDailyTasks, setreadDailyTasks] = useState(false);
  const [isDragTerminated, setIsDragTerminated] = useState(false);
  const [assignTaskPage, setAssignTaskPage] = useState<any>(0);
  const [isTaskNote, setIsTaskNote] = useState(false);
  const [isEditNote, setIsEditNote] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState('');
  const [openAnnounceDialog, setOpenAnnounceDialog] = useState(false);
  const [selectedPatientTask, setSelectedPatientTask] = useState('');
  const [createTaskSource, setSelectedTaskSource] = useState('');

  type SplitMinutes = {
    task1Minutes: number;
    task2Minutes: number;
    uuid: string;
  };

  //split min
  const [openSplitMin, setOpenSplitMin] = useState(false);
  const [sourceOfSplitMin, setSourceOfSplitMin] = useState('');
  const [splitMinPatient, setSplitMinPatient] = useState('');
  const splitMin = useSelector((state: any) => state.SplitTaskMinReducer);
  const editSplitTaskMin = useSelector((state: any) => state.editSplitTaskMinReducer);

  // Appointment scheduling modal
  const [openAppointmentModal, setOpenAppointmentModal] = useState(false);
  const [appointmentPatient, setAppointmentPatient] = useState<any>(null);
  const [appointmentTherapist, setAppointmentTherapist] = useState<any>(null);
  const [migrateRecurring, setMigrateRecurring] = useState(false);

  const settings = useSettings();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const jsDate = moment(selectedDate, 'DD-MM-YYYY').toDate();
  const formattedDate = moment(jsDate).format('MMM D, YYYY');
  const currentDate = moment();
  const [searchData] = useState('');
  const [providerId] = useCurrentUser(['providerId']);
  const therapistList = useSelector((state: any) => state?.getTherapistListReducer?.response?.data);
  const therapistListResponse = useSelector(
    (state: any) => state?.getTherapistListReducer?.localDate
  );
  // THIN-7718: discipline each list response was requested for. Used to reject a late
  // response for a board the user has already navigated away from — see the merge
  // effects below.
  const therapistListDiscipline = useSelector(
    (state: any) => state?.getTherapistListReducer?.discipline
  );
  const patientCardDiscipline = useSelector(
    (state: any) => state?.getAllTherapistTaskReducer?.discipline
  );
  const isTaskAdded = useSelector((state: any) => state.AddTaskToTherapistReducer);
  const isTimeEdited = useSelector((state: any) => state.editTaskTimeReducer);
  const therapistTabs = useSelector((state: any) => state?.therapistDiciplineReducer.data);

  const resScheduling = useSelector((state: any) => state.therapistSchedulingTaskEditReducer);
  const taskType = useSelector((state: any) => state.getAllTherapistTaskTypeReducer?.data);
  const taskTypeBreakdown = useSelector(
    (state: any) => state?.getAllTherapistTaskReducer?.response?.data?.taskTypeBreakdown
  );

  // Ticking a box filters immediately — same reset the Task type dropdown performed.
  const handleTaskTypeToggle = (key: string) => {
    setTaskType((prev: any[]) =>
      prev?.includes(key) ? prev.filter((item: any) => item !== key) : [...(prev || []), key]
    );
    setPatientTaskShowMainLoader(true);
    setPatientTaskPageNo(0);
    setTasklistState([]);
    setTaskSelectedId([]);
  };
  const printStatus = useSelector((state: any) => state.getDailyNotesPrintStatusReducer?.response);
  const canPrintBulkSchedule = Boolean(printStatus?.batchPrint);
  const scheduleAppointmentSuccess = useSelector(
    (state: any) => state?.scheduleAppointmentReducer?.success
  );
  const scheduleRecurringAppointmentSuccess = useSelector(
    (state: any) => state?.scheduleRecurringAppointmentReducer?.success
  );
  const deleteTaskResponse = useSelector((state: any) => state?.deleteTaskPatientReducer);
  const autoMatchResponse = useSelector((state: any) => state?.autoMatchingThearpistReducer);
  const assignTaskResponse = useSelector((state: any) => state?.therapistAssignTaskReducer);
  const migrateTaskResponse = useSelector((state: any) => state?.therapistMigrateTaskReducer);
  const migratePatientResponse = useSelector((state: any) => state?.migrateTherapistPatientReducer);
  const unassignPatientReponse = useSelector(
    (state: any) => state?.therapistPatientUnAssignReducer
  );
  const assignGroupData = useSelector(
    (state: any) => state?.therapistAssignTaskReducer?.response?.data
  );

  const assignGroupDataLoading = useSelector(
    (state: any) => state?.therapistAssignTaskReducer?.loading
  );

  const taskUnAssignLoading = useSelector(
    (state: any) => state?.therapistAssignUndoReducer?.loading
  );

  const patientCard = useSelector(
    (state: any) => state?.getAllTherapistTaskReducer?.response?.data?.content
  );

  const patientTotalElements = useSelector(
    (state: any) => state?.getAllTherapistTaskReducer?.response?.data?.totalElements
  );

  const totalSessionTime = useSelector(
    (state: any) => state?.getAllTherapistTaskReducer?.response?.data?.totalSessionTime
  );
  const totalPatientTime = useSelector(
    (state: any) => state?.getAllTherapistTaskReducer?.response?.data?.totalPatientTime
  );
  // The therapist's persisted choice — the radios follow it once the list lands.
  const savedTimeBasis = useSelector(
    (state: any) => state?.getAllTherapistTaskReducer?.response?.data?.savedTimeBasis
  );
  // Adopt whatever the server last stored, so a reload comes back on the same basis.
  useEffect(() => {
    if (savedTimeBasis === 'LABOR' || savedTimeBasis === 'PATIENT') {
      setTimeBasis(savedTimeBasis);
    }
  }, [savedTimeBasis]);

  const handleTimeBasisChange = (basis: TimeBasis) => {
    setTimeBasis(basis);
    if (providerId) {
      dispatch(updateTimeBasisAction({ providerId, basis }));
    }
  };
  const timeBasisLabel =
    TIME_BASIS_OPTIONS.find((option) => option.value === timeBasis)?.label ?? '';
  const basisSessionTime = timeBasis === 'LABOR' ? totalSessionTime : totalPatientTime;
  const isTaskTypeFiltered = (selectedTaskType?.length ?? 0) > 0;
  const isLastPatientList = useSelector(
    (state: any) => state?.getAllTherapistTaskReducer?.response?.data?.last
  );
  const isLoadingTherapistTask = useSelector(
    (state: any) => state?.getAllTherapistTaskReducer?.loading
  );
  const isLoadingTherapistList = useSelector(
    (state: any) => state?.getTherapistListReducer?.loading
  );

  const scheduleRecurringAppointmentState = useSelector(
    (state: any) => state?.scheduleRecurringAppointmentReducer
  );

  const getTherapistSkillListResponse = useSelector(
    (state: any) => state?.getSkillsListReducer?.response?.data
  );

  const patientDisciplineList = useSelector(
    (state: any) => state?.getAllDisciplineTherapistReducer?.response?.data
  );

  const getAllMaintainedTherapists = useSelector((state: any) => state.getAllMaintainedTherapist);
  const isTaskNoteCreated = useSelector((state: any) => state.createTherapistTaskNoteReducer);
  const isTaskNoteDeleted = useSelector((state: any) => state.deleteTherapistTaskNoteReducer);
  const deleteAnnouncement = useSelector((state: any) => state?.deleteAnnouncementReducer);
  const isSplitTaskDelete = useSelector((state: any) => state.deleteSplitTaskReducer);

  useEffect(() => {
    dispatch(getAllMaintainedTherapistAction(currentTab, providerId));
    dispatch(
      getTherapistSkillList({
        therapistId: providerId,
      })
    );

    dispatch(getEnterprisePayerPlanType());

    dispatch(
      GET_PATIENT_RECORD({
        data: {
          searchString: '',
        },
        params: {
          active: true,
          page: 0,
          pageSize: 20,
        },
      })
    );

    return () => {
      dispatch(resetTherapistAssignDataAction());
      dispatch(getAllTherapistListResetAction());
      dispatch(therapistAssignTaskResetAction());
      dispatch(therapistMigrateTaskResetAction());
      dispatch(migrateTherapisPatientResetAction());
      dispatch(therapistPatientUnAssignReset());
      dispatch(resetAllMaintainedTherapistAction());
      setIsMaintainFilterAvailable(false);
      // setFilterTherapistList([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (getAllMaintainedTherapists.fetched) {
      setFilterTherapistList(
        getAllMaintainedTherapists?.data?.length ? getAllMaintainedTherapists?.data : []
      );
      setIsMaintainFilterAvailable(true);
    }
  }, [getAllMaintainedTherapists]);

  useEffect(() => {
    if (providerId && selectedDate) {
      dispatch(
        getDailyNotesPrintStatus({
          therapistUuid: providerId,
          date: moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    providerId,
    selectedDate,
    currentTab,
    assignTaskResponse?.isTherapistAssignTask,
    unassignPatientReponse?.isSuccess,
    deleteTaskResponse?.isTaskDelete,
    isTaskAdded?.isTaskAdded,
    splitMin?.isMinSplit,
    editSplitTaskMin?.isTaskMinEdited,
    scheduleAppointmentSuccess,
    scheduleRecurringAppointmentSuccess,
    taskUnAssignLoading,
  ]);

  useEffect(() => {
    return () => {
      dispatch(resetDailyNotesPrintStatus());
    };
  }, [providerId, selectedDate, dispatch]);

  // useEffect(() => {
  //   if (assignGroupData && assignGroupData?.label && closeGroupDialog) {
  //     setOpenGroupDialog(true);
  //     setCloseGroupDialog(false);
  //   } else {
  //     setTaskSelectedId([]);
  //   }
  // }, [assignGroupData]);

  useEffect(() => {
    if (assignTaskResponse?.response === null && !assignTaskResponse?.isTherapistAssignTask) return;
    // Show error message only if assignment failed
    if (assignTaskResponse?.response !== null && !assignTaskResponse?.isTherapistAssignTask) {
      setPopUpMessage({
        message: assignTaskResponse?.response?.error || assignTaskResponse?.response?.message,
        type: 'ERROR',
      });

      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
      }, 3000);
      // Reset state so a retry starts clean. Without this, a leftover
      // reloadUpToPageRef value would trigger spurious page refreshes on the
      // next unrelated action.
      reloadUpToPageRef.current = 0;
      dispatch(therapistAssignTaskResetAction());
      return;
    }
    // On success, silently reset without showing success message
    // Skip reset if assignGroupData has a label — the group dialog needs the data to stay open
    if (assignTaskResponse?.isTherapistAssignTask && assignTaskResponse?.response) {
      // Authoritatively drop any tasks the backend reports as no longer
      // unscheduled. This applies to every success response (including
      // intermediate dialog steps for group/concurrent flows) and is what
      // closes the duplicate-task race that the merge effect can't fix on
      // its own (the merge dedup never REMOVES items, only deduplicates).
      const removedUuids: string[] | undefined =
        assignTaskResponse?.response?.data?.removedTaskUuids;
      if (Array.isArray(removedUuids) && removedUuids.length > 0) {
        const removedSet = new Set(removedUuids);
        setTasklistState((prev: any[]) =>
          (prev || []).filter((task: any) => !removedSet.has(task?.uuid))
        );
        // Also drop the just-assigned uuids from the checkbox selection so a
        // subsequent drag of the remaining unassigned tasks doesn't
        // accidentally re-migrate the ones that already got assigned.
        setTaskSelectedId((prev: any[]) =>
          (prev || []).filter((uuid: any) => !removedSet.has(uuid))
        );
      }
      if (
        !assignTaskResponse?.response?.data?.label &&
        !assignTaskResponse?.response?.data?.concurrentAndGroupSession?.length
      ) {
        // Clear the multi-select checkboxes once the assign flow fully
        // completes — otherwise the previously-picked tasks stay ticked and
        // re-appear pre-selected if the same tasks show up again (e.g. after
        // unassigning them).
        setTaskSelectedId([]);
        dispatch(therapistAssignTaskResetAction());
        if (reloadUpToPageRef.current > 0) {
          const targetPage = reloadUpToPageRef.current;
          reloadUpToPageRef.current = 0;
          for (let page = 1; page <= targetPage; page++) {
            dispatch(
              getAllTherapistTaskAction({
                pageNo: page,
                data: {
                  type: selectedTaskType?.length ? selectedTaskType : [],
                  active: true,
                  discipline: currentTab ? currentTab : '',
                  localDate: selectedDate
                    ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
                    : '',
                  providerId,
                  skill: currentSkillSelected ? currentSkillSelected : '',
                  isV2: true,
                },
              })
            );
          }
          skipNextTaskFetchRef.current = true;
          setPatientTaskPageNo(targetPage);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignTaskResponse, dispatch]);

  useEffect(() => {
    if (migrateTaskResponse?.response === null && !migrateTaskResponse?.isTherapistTaskMigrated) {
      return;
    }
    // Show error message only if migration failed
    if (migrateTaskResponse?.response !== null && !migrateTaskResponse?.isTherapistTaskMigrated) {
      setPopUpMessage({
        message: migrateTaskResponse?.response?.error || migrateTaskResponse?.response?.message,
        type: 'ERROR',
      });

      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
      }, 3000);
      dispatch(therapistMigrateTaskResetAction());
      return;
    }
    // On success, silently reset without showing success message
    if (migrateTaskResponse?.isTherapistTaskMigrated && migrateTaskResponse?.response) {
      dispatch(therapistMigrateTaskResetAction());
    }
  }, [migrateTaskResponse, dispatch]);

  useEffect(() => {
    if (
      migratePatientResponse?.response === null &&
      !migratePatientResponse?.isPatientTasksMigrated
    ) {
      return;
    }
    // Show error message only if migration failed
    if (
      migratePatientResponse?.response !== null &&
      !migratePatientResponse?.isPatientTasksMigrated
    ) {
      setPopUpMessage({
        message:
          migratePatientResponse?.response?.error || migratePatientResponse?.response?.message,
        type: 'ERROR',
      });

      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
      }, 3000);
      dispatch(migrateTherapisPatientResetAction());
      return;
    }
    // On success, silently reset without showing success message
    if (migratePatientResponse?.isPatientTasksMigrated && migratePatientResponse?.response) {
      dispatch(migrateTherapisPatientResetAction());
    }
  }, [migratePatientResponse, dispatch]);

  useEffect(() => {
    if (deleteTaskResponse?.response === null && !deleteTaskResponse?.isTaskDelete) return;
    else if (deleteTaskResponse?.response !== null && !deleteTaskResponse?.isTaskDelete) {
      setPopUpMessage({
        message: deleteTaskResponse?.response?.error || deleteTaskResponse?.response?.message,
        type: 'ERROR',
      });
      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
        dispatch(resetDeletePatientTask());
      }, 3000);
    } else if (deleteTaskResponse?.response !== null && deleteTaskResponse?.isTaskDelete) {
      setPopUpMessage({
        message: deleteTaskResponse?.response?.message,
        type: '',
        hideSuccessIcon: true,
      });
      // Drop the deleted task from the local task queue immediately. The
      // patientCard merge effect only dedupes/appends — it never removes — so
      // without this filter the deleted pre-admit task lingers in the UI
      // until a manual reload (THIN: pre-admit Evaluation deletion).
      if (currentPatientTask) {
        setTasklistState((prev: any[]) =>
          prev.filter((item: any) => item?.uuid !== currentPatientTask)
        );
      }
      dispatch(
        disableAutoMatchAction({
          providerId,
          discipline: currentTab ? currentTab : '',
          currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        })
      );
      dispatch(
        getAllTherapistTaskAction({
          pageNo: patientTaskPageNo,
          data: {
            type: selectedTaskType?.length ? selectedTaskType : [],
            active: true,
            discipline: currentTab ? currentTab : '',
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            providerId,
            skill: currentSkillSelected ? currentSkillSelected : '',
            searchString: patientSearchString,
            isV2: true,
          },
        })
      );
      dispatch(
        getAllTherapistDiciplineAction({
          providerId,
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          data: {
            isV2: true,
          },
        })
      );
      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
        dispatch(resetDeletePatientTask());
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteTaskResponse]);

  useEffect(() => {
    if (autoMatchResponse?.response === null && !autoMatchResponse?.isTaskAssigned) return;
    else if (autoMatchResponse?.response !== null && !autoMatchResponse?.isTaskAssigned) {
      setPopUpMessage({
        message: autoMatchResponse?.response?.error || autoMatchResponse?.response?.message,
        type: 'ERROR',
      });
      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
        dispatch(autoMatchingTherapistResetAction());
      }, 3000);
    } else if (autoMatchResponse?.response !== null && autoMatchResponse?.isTaskAssigned) {
      setPopUpMessage({
        message: autoMatchResponse?.response?.message,
        type: '',
      });
      // Authoritatively drop any tasks the backend reports as no longer
      // unscheduled. The auto-match success refresh below only re-fetches
      // the current page; the merge effect on patientCard adds new items
      // but never removes — so without this filter, just-assigned tasks
      // (and any on pages outside the refreshed range) stay duplicated
      // in the unscheduled list. Mirrors the drag-drop fix above.
      const removedUuids: string[] | undefined =
        autoMatchResponse?.response?.data?.removedTaskUuids;
      if (Array.isArray(removedUuids) && removedUuids.length > 0) {
        const removedSet = new Set(removedUuids);
        setTasklistState((prev: any[]) =>
          (prev || []).filter((task: any) => !removedSet.has(task?.uuid))
        );
        // Also drop the just-assigned uuids from the checkbox selection so a
        // subsequent drag of the remaining unassigned tasks doesn't
        // accidentally re-migrate the ones that already got assigned.
        setTaskSelectedId((prev: any[]) =>
          (prev || []).filter((uuid: any) => !removedSet.has(uuid))
        );
      }
      dispatch(
        disableAutoMatchAction({
          providerId,
          discipline: currentTab ? currentTab : '',
          currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        })
      );
      dispatch(
        getAllTherapistTaskAction({
          pageNo: patientTaskPageNo,
          data: {
            type: selectedTaskType?.length ? selectedTaskType : [],
            active: true,
            discipline: currentTab ? currentTab : '',
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            providerId,
            skill: currentSkillSelected ? currentSkillSelected : '',
            searchString: patientSearchString,
            isV2: true,
          },
        })
      );
      dispatch(
        getAllTherapistListAction({
          pageNo: therapistListPageNo,
          data: {
            providerId,
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            discipline: currentTab ? currentTab : '',
            sortBy: selectedSortType ? selectedSortType : '',
            signal: abortControllerRef.current.signal,
            searchData,
            filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
            isV2: true,
          },
        })
      );
      dispatch(
        getAllTherapistDiciplineAction({
          providerId,
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          data: {
            isV2: true,
          },
        })
      );
      setIsStatsRefresh(true);
      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
        dispatch(autoMatchingTherapistResetAction());
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoMatchResponse]);

  useEffect(() => {
    if (unassignPatientReponse?.response === null && !unassignPatientReponse?.isSuccess) {
      return;
    }
    // Show error message only if unassignment failed
    if (unassignPatientReponse?.response !== null && !unassignPatientReponse?.isSuccess) {
      setPopUpMessage({
        message:
          unassignPatientReponse?.response?.error || unassignPatientReponse?.response?.message,
        type: 'ERROR',
      });

      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
      }, 3000);
      // Reset state so a retry starts clean. Without this, the failed response
      // sits in Redux and a leftover reloadUpToPageRef value could trigger
      // spurious page refreshes on the next unrelated action.
      reloadUpToPageRef.current = 0;
      dispatch(therapistPatientUnAssignReset());
      return;
    }
    // On success, silently reset without showing success message
    if (unassignPatientReponse?.isSuccess && unassignPatientReponse?.response) {
      dispatch(therapistPatientUnAssignReset());
      if (reloadUpToPageRef.current > 0) {
        const targetPage = reloadUpToPageRef.current;
        reloadUpToPageRef.current = 0;
        for (let page = 1; page <= targetPage; page++) {
          dispatch(
            getAllTherapistTaskAction({
              pageNo: page,
              data: {
                type: selectedTaskType?.length ? selectedTaskType : [],
                active: true,
                discipline: currentTab ? currentTab : '',
                localDate: selectedDate
                  ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
                  : '',
                providerId,
                skill: currentSkillSelected ? currentSkillSelected : '',
                isV2: true,
              },
            })
          );
        }
        skipNextTaskFetchRef.current = true;
        setPatientTaskPageNo(targetPage);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unassignPatientReponse, dispatch]);

  useEffect(() => {
    setNoOfTherapistEditDialogOpen([]);
    therapistListState?.forEach((_e) => {
      setNoOfTherapistEditDialogOpen((prev: any[]) => [...prev, false]);
    });
  }, [therapistListState]);

  useEffect(() => {
    dispatch(getSingleTherapistAction({ discipline: currentTab }));
  }, [currentTab, dispatch]);

  useEffect(() => {
    // THIN-7718: reject a response that was requested for a different discipline than the
    // board now on screen. The fetch watcher is takeEvery and the mutation sagas re-trigger
    // it with no abort signal, so a request issued before a tab switch can resolve after
    // the new board's request. Merging it here put off-discipline tasks into the visible
    // queue, and dragging one of those onto a therapist bound e.g. an OT task to a PT
    // therapist. Only drop when the tag is present and actually differs, so any dispatcher
    // that does not supply a discipline keeps its previous behaviour.
    if (isDisciplineMismatch(patientCardDiscipline, currentTabRef.current)) {
      return;
    }
    setTasklistState((prev: any) => {
      const prevArray = Array.isArray(prev) ? prev : [];
      if (prevArray.length === 0) {
        return patientCard || [];
      }
      const patientCardArray = Array.isArray(patientCard) ? patientCard : [];
      const mergedArray = [...prevArray, ...patientCardArray];
      const uniqueMap = new Map(mergedArray?.map((item) => [item.uuid, item]));
      return Array.from(uniqueMap?.values());
    });
    setPatientTaskShowMainLoader(true);
    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientCard]);

  useEffect(() => {
    // THIN-7718: same stale-response guard as the task list above. The existing check
    // below only compares the response's localDate, which lets a response for the
    // previous discipline through and pollutes the therapist column — the mirror image of
    // the task-list defect, and why the production data shows the fault in both
    // directions (OT task on a PT therapist and PT task on an OT/SLP therapist).
    if (isDisciplineMismatch(therapistListDiscipline, currentTabRef.current)) {
      return;
    }
    if (
      therapistListPageNo === 0 &&
      moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') === therapistListResponse
    ) {
      setTherapistListState(therapistList?.content);
    } else if (moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') === therapistListResponse) {
      setTherapistListState((prev: any) => {
        const mergedArray = [...prev, ...(therapistList?.content || [])];
        const uniqueMap = new Map(mergedArray.map((item) => [item.uuid, item]));
        const uniqueArray = Array.from(uniqueMap?.values());
        return uniqueArray;
      });
    }
    setTherapistTaskMainLoader(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [therapistList]);

  useEffect(() => {
    if (taskListState && therapistListState && taskListState.length > patientTotalElementsState) {
      const uuidsInA = new Set(
        therapistListState
          .flatMap((item: any) => item.assignedTaskList?.map((task: any) => task.taskUuids))
          .flat()
      );
      const filteredB = taskListState.filter((item) => !uuidsInA.has(item.uuid));
      setTasklistState(filteredB);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskListState, therapistListState]);

  useEffect(() => {
    setShowLoader(
      assignGroupDataLoading ||
        autoMatchResponse?.loading ||
        taskUnAssignLoading ||
        unassignPatientReponse?.loading
    );
  }, [assignGroupDataLoading, autoMatchResponse, taskUnAssignLoading, unassignPatientReponse]);

  useEffect(() => {
    setPatientTotalElementsState(patientTotalElements);
  }, [patientTotalElements]);

  useEffect(() => {
    if (skipNextTaskFetchRef.current) {
      skipNextTaskFetchRef.current = false;
      return;
    }
    if (selectedDate) {
      abortControllerPatinetListRef.current = new AbortController();
      dispatch(
        disableAutoMatchAction({
          providerId,
          discipline: currentTab ? currentTab : '',
          currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        })
      );
      dispatch(
        getAllTherapistTaskAction({
          pageNo: patientTaskPageNo,
          data: {
            type: selectedTaskType?.length ? selectedTaskType : [],
            active: true,
            discipline: currentTab ? currentTab : '',
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            signal: abortControllerPatinetListRef?.current?.signal,
            providerId,
            skill: currentSkillSelected ? currentSkillSelected : '',
            searchString: patientSearchString,
            isV2: true,
          },
        })
      );

      dispatch(
        getAllTherapistDiciplineAction({
          providerId,
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          data: {
            isV2: true,
          },
        })
      );
    } else {
      handleChangeDate(new Date());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedTaskType,
    currentTab,
    selectedDate,
    providerId,
    dispatch,
    patientTaskPageNo,
    currentSkillSelected,
    patientSearchString,
  ]);

  useEffect(() => {
    setMeta({
      providerId,
      type: selectedTaskType?.length ? selectedTaskType : [],
      active: true,
      discipline: currentTab ? currentTab : '',
      date: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
      skill: currentSkillSelected ? currentSkillSelected : '',
      sortBy: selectedSortType ? selectedSortType : '',
      taskPage: 0,
      filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
      therapistPage: therapistListPageNo,
    });
  }, [
    selectedTaskType,
    currentTab,
    selectedDate,
    filterTherapistList,
    providerId,
    therapistListPageNo,
    currentSkillSelected,
    selectedSortType,
  ]);

  useEffect(() => {
    if (selectedDate && isMaintainFilterAvailable) {
      abortControllerRef.current = new AbortController();

      dispatch(
        getAllTherapistListAction({
          pageNo: therapistListPageNo,
          data: {
            providerId,
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            discipline: currentTab ? currentTab : '',
            sortBy: selectedSortType ? selectedSortType : '',
            signal: abortControllerRef.current.signal,
            searchData,
            filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
            isV2: true,
          },
        })
      );
    }
  }, [
    selectedDate,
    filterTherapistList,
    selectedSortType,
    providerId,
    dispatch,
    searchData,
    therapistListPageNo,
    currentTab,
    isMaintainFilterAvailable,
  ]);

  useEffect(() => {
    if (selectedDate) {
      dispatch(
        getAllDisciplineTherapist({
          pageNo: 0,
          data: {
            providerId,
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            discipline: currentTab ? currentTab : '',
            sortBy: selectedSortType ? selectedSortType : '',
            searchData: '',
            forFilter: true,
          },
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, providerId, dispatch, currentTab]);

  useEffect(() => {
    dispatch(
      getAllTaskTypeAction({
        providerId,
        active: true,
      })
    );
  }, [providerId, dispatch, selectedDate]);

  // THIN-8077: these two read through the scope checker like the rest of the file, rather than
  // matching display names off currentPermissions. `Read Daily Task` is now `View Scheduling
  // Board`, so the old string match would have gone permanently false and hidden the board.
  useEffect(() => {
    setreadDailyTasks(has(Permissions.READ_DAILY_TASK));
    setUpdateDailyTasks(has(Permissions.UPDATE_DAILY_TASK));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionData]);

  useEffect(() => {
    if (isLoadingTherapistTask || isLoadingTherapistList) {
      if (!isDragTerminated) {
        document.dispatchEvent(new MouseEvent('mouseup'));
        setIsDragTerminated(true);
      }
    }
  }, [isLoadingTherapistList, isLoadingTherapistTask, isDragTerminated]);

  useEffect(() => {
    if (!resScheduling?.isEditedTask && resScheduling?.response === null) return;

    if (!resScheduling?.isEditedTask && resScheduling?.response !== null) {
      setReSchedulingTask(false);
      dispatch(editTaskTherapistSchedulingResetAction());
      return;
    }
    setSuccessModalTitle((prev) => ({
      ...prev,
      title: 'Task reschedule  Successfully!',
      message: '',
    }));
    setReSchedulingTask(false);
    setSuccessFullRequest(true);
    if (selectedReSchedulingTask?.uuid) {
      setTasklistState((prev: any[]) =>
        prev.filter((item: any) => item?.uuid !== selectedReSchedulingTask?.uuid)
      );
    }
    dispatch(editTaskTherapistSchedulingResetAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resScheduling]);

  useEffect(() => {
    if (openCalender) {
      const handleClickOutside = (event: any) => {
        if (calenderRef.current && !calenderRef.current.contains(event.target)) {
          handleClickCalender();
        }
      };

      document.addEventListener('click', handleClickOutside);

      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, [openCalender]);

  useEffect(() => {
    if (!isTaskAdded.isTaskAdded && isTaskAdded?.response === null) return;

    if (!isTaskAdded.isTaskAdded && isTaskAdded?.response !== null) {
      dispatch(resetAddNewTaskTherapist());
      return;
    }
    setOpenAddTaskForm(false);
    //new code
    setTasklistState([]);
    setPatientTaskPageNo(0);

    setSuccessModalTitle((prev) => ({
      ...prev,
      title: 'Task added successfully!',
      message: '',
    }));
    setSuccessFullRequest(true);
    dispatch(resetAddNewTaskTherapist());
  }, [isTaskAdded, dispatch]);

  useEffect(() => {
    if (!isTimeEdited.isTimeEdited && isTimeEdited?.response === null) return;

    if (isTimeEdited.isTimeEdited && isTimeEdited?.response !== null) {
      handleEditTime(isTimeEdited?.isAssigned);
      setOpenEditTimeDialog(false);
      setNoOfTherapistEditDialogOpen([]);
      therapistListState?.forEach((_e) => {
        setNoOfTherapistEditDialogOpen((prev: any[]) => [...prev, false]);
      });

      // Only show success message if suppressSuccessMessage flag is not set
      if (!isTimeEdited?.suppressSuccessMessage) {
        setSuccessModalTitle((prev) => ({
          ...prev,
          title: 'Time edited successfully!',
          message: `Time has been successfully updated`,
        }));
        setSuccessFullRequest(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTimeEdited]);

  useEffect(() => {
    if (!isTaskNoteCreated.isTaskCreated && isTaskNoteCreated?.response === null) return;
    // Show error message only if note creation failed
    if (!isTaskNoteCreated.isTaskCreated && isTaskNoteCreated?.response !== null) {
      dispatch(resetCreateTherapistTaskNote());
      setIsTaskNote(false);
      return;
    }

    // On success, silently close dialog and refresh without showing success message
    // Success handling is now done in schedule-task-note.tsx component
    if (isTaskNoteCreated.isTaskCreated && isTaskNoteCreated?.response !== null) {
      getTherapistAndTask();
      setIsTaskNote(false);
      // Success message is suppressed - handled in schedule-task-note.tsx
      dispatch(resetCreateTherapistTaskNote());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTaskNoteCreated]);

  useEffect(() => {
    if (splitMin?.response === null && !splitMin.isMinSplit) return;
    if (splitMin?.response !== null && !splitMin.isMinSplit) {
      dispatch(resetSplitTaskMinAction());
      setOpenSplitMin(false);
      return;
    }

    if (splitMin?.response !== null && splitMin.isMinSplit) {
      setTherapistTaskMainLoader(true);
      setPatientTaskShowMainLoader(true);
      setPatientTaskPageNo(0);
      setTasklistState([]);

      dispatch(
        getAllTherapistTaskAction({
          pageNo: 0,
          data: {
            type: selectedTaskType?.length ? selectedTaskType : [],
            active: true,
            discipline: currentTab ? currentTab : '',
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            signal: abortControllerPatinetListRef?.current?.signal,
            providerId,
            skill: currentSkillSelected ? currentSkillSelected : '',
            searchString: patientSearchString,
            isV2: true,
          },
        })
      );
      dispatch(
        getAllTherapistDiciplineAction({
          providerId,
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          data: {
            isV2: true,
          },
        })
      );
      setOpenSplitMin(false);
      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Task minutes split successfully',
        message: `Current task is duplicated to the task list for the day`,
      }));
      setSuccessFullRequest(true);
      dispatch(resetSplitTaskMinAction());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [splitMin]);

  useEffect(() => {
    if (editSplitTaskMin?.response === null && !editSplitTaskMin.isTaskMinEdited) return;
    if (editSplitTaskMin?.response !== null && !editSplitTaskMin.isTaskMinEdited) {
      dispatch(editResetSplitTaskMinAction());
      dispatch(resetSplitTaskMinAction());
      setOpenSplitMin(false);
      return;
    }
    if (editSplitTaskMin?.response !== null && editSplitTaskMin.isTaskMinEdited) {
      setTherapistTaskMainLoader(true);
      setPatientTaskShowMainLoader(true);
      setPatientTaskPageNo(0);
      setTasklistState([]);
      dispatch(
        getAllTherapistTaskAction({
          pageNo: 0,
          data: {
            type: selectedTaskType?.length ? selectedTaskType : [],
            active: true,
            discipline: currentTab ? currentTab : '',
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            signal: abortControllerPatinetListRef?.current?.signal,
            providerId,
            skill: currentSkillSelected ? currentSkillSelected : '',
            searchString: patientSearchString,
            isV2: true,
          },
        })
      );
      dispatch(
        getAllTherapistDiciplineAction({
          providerId,
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          data: {
            isV2: true,
          },
        })
      );
      getRightSideList();
      setOpenSplitMin(false);
      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Task minutes split successfully',
        message: `Current task is duplicated to the task list for the day`,
      }));
      setSuccessFullRequest(true);
      dispatch(editResetSplitTaskMinAction());
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editSplitTaskMin]);

  useEffect(() => {
    if (!isTaskNoteDeleted.isDeletedTaskNote && isTaskNoteDeleted?.response === null) return;
    if (!isTaskNoteDeleted.isDeletedTaskNote && isTaskNoteDeleted?.response !== null) {
      dispatch(resetDeleteTherapistTaskNote());
      return;
    }

    if (isTaskNoteDeleted.isDeletedTaskNote && isTaskNoteDeleted?.response !== null) {
      getTherapistAndTask();
      setPopUpMessage({
        message: '',
        type: '',
        hideSuccessIcon: true,
      });
      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
      }, 3000);
      dispatch(resetDeleteTherapistTaskNote());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTaskNoteDeleted]);

  useEffect(() => {
    if (scheduleRecurringAppointmentState?.success && !isLoadingTherapistTask) {
      // Clear the data and refresh TherapistSchedule when recurring appointment is scheduled
      setPatientTaskPageNo(0);
      setTasklistState([]);
      getTherapistAndTask();
      dispatch(scheduleRecurringAppointmentResetAction());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleRecurringAppointmentState?.success, dispatch]);

  useEffect(() => {
    if (!isSplitTaskDelete.deleteSplitTask && isSplitTaskDelete?.response === null) return;
    if (!isSplitTaskDelete.deleteSplitTask && isSplitTaskDelete?.response !== null) {
      dispatch(resetDeleteSplitTaskAction());
      return;
    }

    if (isSplitTaskDelete.deleteSplitTask && isSplitTaskDelete?.response !== null) {
      setTherapistTaskMainLoader(true);
      setPatientTaskShowMainLoader(true);
      setPatientTaskPageNo(0);
      setTasklistState([]);

      dispatch(
        getAllTherapistTaskAction({
          pageNo: 0,
          data: {
            type: selectedTaskType?.length ? selectedTaskType : [],
            active: true,
            discipline: currentTab ? currentTab : '',
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            signal: abortControllerPatinetListRef?.current?.signal,
            providerId,
            skill: currentSkillSelected ? currentSkillSelected : '',
            searchString: patientSearchString,
            isV2: true,
          },
        })
      );
      dispatch(
        getAllTherapistDiciplineAction({
          providerId,
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          data: {
            isV2: true,
          },
        })
      );
      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Split Task Deleted successfully',
        message: '',
      }));
      setSuccessFullRequest(true);
      dispatch(resetDeleteSplitTaskAction());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSplitTaskDelete]);

  useEffect(() => {
    if (!deleteAnnouncement?.response) return;
    if (deleteAnnouncement?.response !== null && deleteAnnouncement?.response?.code !== 'OK') {
      setPopUpMessage({ message: deleteAnnouncement?.response?.message, type: 'ERROR' });
      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
      }, 3000);
      dispatch(resetDeleteAnnouncementAction());
      return;
    }
    setPopUpMessage({ message: deleteAnnouncement?.response?.message, type: '' });
    setTimeout(() => {
      setPopUpMessage({ message: '', type: '' });
    }, 3000);
    dispatch(resetDeleteAnnouncementAction());
  }, [deleteAnnouncement, dispatch]);

  const handleTabsChange = (_event: ChangeEvent<any>, value: string): void => {
    setIsMaintainFilterAvailable(false);
    dispatch(resetAllMaintainedTherapistAction());
    setFilterTherapistList([]);
    abortControllerRef.current.abort();
    abortControllerPatinetListRef.current.abort();
    dispatch(getAllMaintainedTherapistAction(value, providerId));
    setCurrentTab(value);
    setPatientTaskShowMainLoader(true);
    setPatientTaskPageNo(0);
    setTherapistListPageNo(0);
    setTherapistListState([]);
    setTasklistState([]);
    setTaskSelectedId([]);
  };

  const rearrangeTask = (taskList: any) => {
    const convertedResponse = taskList?.map(function (item: any, index: number) {
      return {
        taskSchedulingId: item.uuid,
        priority: taskList.length - index,
      };
    });
    dispatch(
      reassignTherapistTaskAction({
        providerId,
        dicipline: currentTab,
        data: convertedResponse,
      })
    );
  };

  function getTherapistPageNumber(therapistList: any, therapistUuid: string): number {
    const therapistsPerPage = 20;

    const index = therapistList?.findIndex((therapist: any) => therapist?.uuid === therapistUuid);
    if (index === -1) return -1;
    return Math.floor(index / therapistsPerPage);
  }

  const dragUnassign = (taskId: string, therapistId: string) => {
    dispatch(
      therapistAssignUndoAction({
        providerId,
        type: selectedTaskType?.length ? selectedTaskType : [],
        active: true,
        searchData,
        currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',

        filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
        meta: {
          providerId,
          type: selectedTaskType?.length ? selectedTaskType : [],
          active: true,
          discipline: currentTab ? currentTab : '',
          date: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          skill: currentSkillSelected ? currentSkillSelected : '',
          sortBy: selectedSortType ? selectedSortType : '',
          taskPage: 0,
          therapistPage: 0,
        },
        discipline: currentTab ? currentTab : '',
        date: selectedDate,
        skill: currentSkillSelected ? currentSkillSelected : '',
        sortBy: selectedSortType ? selectedSortType : '',
        therapistId: therapistId ? therapistId : '',
        taskType: 'task-uuid',
        taskId: taskId ? taskId : '',
        requestBody: {
          taskUuids: [taskId],
          groupUuid: null,
        },
        isV2: true,
      })
    );
  };

  const patientUnAssign = (patientId: string, therapistId: string) => {
    reloadUpToPageRef.current = patientTaskPageNo;
    // Do NOT optimistically clear taskListState here. On API failure the cleared
    // state is never restored, which misleads the user into thinking the unassign
    // succeeded. The unassign response carries addedTaskUuids and the post-success
    // refresh chain will pull in the full task data for those UUIDs.
    // Check if this is a futureAdmission (patientId starts with "future-")
    const isFutureAdmission = patientId?.startsWith('future-');

    if (isFutureAdmission) {
      // Extract taskUuid from "future-{taskUuid}"
      const taskUuid = patientId?.replace('future-', '') || '';

      // For futureAdmissions, use therapistAssignUndoAction
      dispatch(
        therapistAssignUndoAction({
          providerId,
          type: selectedTaskType?.length ? selectedTaskType : [],
          active: true,
          searchData,
          currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
          meta: {
            providerId,
            type: selectedTaskType?.length ? selectedTaskType : [],
            active: true,
            discipline: currentTab ? currentTab : '',
            date: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            skill: currentSkillSelected ? currentSkillSelected : '',
            sortBy: selectedSortType ? selectedSortType : '',
            taskPage: 0,
            therapistPage: 0,
          },
          discipline: currentTab ? currentTab : '',
          date: selectedDate,
          skill: currentSkillSelected ? currentSkillSelected : '',
          sortBy: selectedSortType ? selectedSortType : '',
          therapistId: therapistId ? therapistId : '',
          taskType: 'task-uuid',
          taskId: taskUuid ? taskUuid : '',
          requestBody: {
            taskUuids: [taskUuid],
            groupUuid: null,
          },
          isV2: true,
        })
      );
    } else {
      // For regular patients, use therapistPatientUnAssignAction
      dispatch(
        therapistPatientUnAssignAction({
          providerId,
          therapistId: therapistId ? therapistId : '',
          currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          patientId: patientId ? patientId : '',
          type: selectedTaskType?.length ? selectedTaskType : [],
          active: true,
          searchData,
          filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
          discipline: currentTab ? currentTab : '',
          date: selectedDate,
          skill: currentSkillSelected ? currentSkillSelected : '',
          sortBy: selectedSortType ? selectedSortType : '',
          meta: {
            providerId,
            type: selectedTaskType?.length ? selectedTaskType : [],
            active: true,
            discipline: currentTab ? currentTab : '',
            date: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            skill: currentSkillSelected ? currentSkillSelected : '',
            sortBy: selectedSortType ? selectedSortType : '',
            taskPage: 0,
            therapistPage: 0,
          },
          isV2: true,
        })
      );
    }
  };

  const dragAndDropProcessing = (result: any) => {
    const { source, destination, draggableId } = result;

    // Check if the dragged item is an APPOINTMENT type
    if (source.droppableId === 'ROOT' && destination.droppableId !== 'ROOT') {
      const draggedPatient = taskListState?.find((item: any) => item?.uuid === draggableId);

      if (draggedPatient?.scheduleItemType === 'APPOINTMENT') {
        // Find the destination therapist
        const destinationTherapist = therapistListState?.find(
          (therapist: any) => therapist?.uuid === destination.droppableId
        );

        if (destinationTherapist) {
          setAppointmentPatient(draggedPatient);
          setAppointmentTherapist(destinationTherapist);
          setOpenAppointmentModal(true);
        }
        return;
      }
    }

    if (destination.droppableId === 'ROOT' && draggableId.includes('~')) {
      const patientId = draggableId.split('~')[0];
      const sourceTherapistId = source.droppableId;

      patientUnAssign(patientId, sourceTherapistId);
      return;
    }

    if (destination.droppableId === 'ROOT' && draggableId.includes('+')) {
      const taskId = draggableId.split('+')[0];
      const sourceTherapistId = source.droppableId;
      dragUnassign(taskId, sourceTherapistId);
      return;
    }

    if (destination.droppableId === 'ROOT') {
      const sourceIndex = source.index;
      const destinationIndex = destination.index;
      setTasklistState((prevState) => {
        const reorderedStore = [...prevState];
        const [removedStore] = reorderedStore.splice(sourceIndex, 1);
        reorderedStore.splice(destinationIndex, 0, removedStore);
        rearrangeTask(reorderedStore);
        return reorderedStore;
      });
      return;
    }
    reloadUpToPageRef.current = patientTaskPageNo;
    // Do NOT optimistically clear taskListState here. On API failure the cleared
    // state is never restored, which misleads the user into thinking the
    // assignment succeeded when the backend rejected it. The assign response
    // carries removedTaskUuids which the assignTaskResponse effect uses to
    // authoritatively drop the just-assigned tasks from taskListState.
    // Suppress the auto-fetch that the patientTaskPageNo change would trigger:
    // its stale page-0 response can race in after the removedTaskUuids filter
    // and re-introduce the just-assigned task. The saga's post-success page-0
    // refresh + the post-success effect's pages 1..N refresh cover this page.
    if (patientTaskPageNo > 0) {
      skipNextTaskFetchRef.current = true;
    }
    setPatientTaskPageNo(0);

    if (draggableId.includes('+') && source.droppableId !== destination.droppableId) {
      const taskId = draggableId.split('+')[0];
      const sourceTherapistId = source.droppableId;
      const destinationTherapistId = destination.droppableId;

      // Check if this is an outpatient appointment being dragged
      const sourceTherapist = therapistListState?.find(
        (therapist: any) => therapist?.uuid === sourceTherapistId
      );
      let isOutPatientAppointment = false;
      let patientData: any = null;

      if (sourceTherapist?.assignedPatients) {
        // Find the patient by checking all assignedPatients for matching taskUuid in appointments
        for (const [patientId, patient] of Object.entries(sourceTherapist.assignedPatients)) {
          const assignedPatient = patient as any;
          if (assignedPatient?.isOutPatient === true && assignedPatient?.appointments) {
            const matchingAppointment = assignedPatient.appointments.find(
              (appt: any) => appt?.taskUuid === taskId
            );
            if (matchingAppointment) {
              isOutPatientAppointment = true;
              patientData = {
                ...assignedPatient,
                patientId: patientId,
                patientUuid: patientId,
                uuid: patientId,
                sourceTherapistId: sourceTherapistId,
                destinationTherapistId: destinationTherapistId,
                sourceTherapist: sourceTherapist,
                destinationTherapist: therapistListState?.find(
                  (t: any) => t?.uuid === destinationTherapistId
                ),
                appointments: assignedPatient.appointments || [],
                taskUuid: taskId,
                taskId: taskId,
                numberOfMinutes:
                  matchingAppointment?.numberOfMinutes || assignedPatient?.numberOfMinutes || 30,
              };
              break;
            }
          }
        }
      }

      if (isOutPatientAppointment && patientData) {
        // Find destination therapist
        const destinationTherapist = therapistListState?.find(
          (therapist: any) => therapist?.uuid === destinationTherapistId
        );

        if (destinationTherapist) {
          setAppointmentPatient(patientData);
          setAppointmentTherapist(destinationTherapist);
          setOpenAppointmentModal(true);
        }
        return;
      }

      const selectedTaskForDrop = sourceTherapistId;
      setTherapistIdToDrop(destination.droppableId);
      const allTherapistListData = [...therapistListState];
      const sourcePage = getTherapistPageNumber(allTherapistListData, selectedTaskForDrop);
      const destinationPage = getTherapistPageNumber(allTherapistListData, destination.droppableId);
      dispatch(
        therapistMigrateTaskAction({
          providerId,
          currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          sourceTherapist: sourceTherapistId,
          targetTherapist: destinationTherapistId,
          filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
          taskId: taskId,
          singleAssign: true,
          meta: meta,
          sourcePage: sourcePage,
          destinationPage: destinationPage,
          isV2: true,
        })
      );
      return;
    }

    if (draggableId.includes('~') && source.droppableId !== destination.droppableId) {
      const patientIdPart: string | null = draggableId.split('~')[0];
      const sourceTherapistId = source.droppableId;
      const destinationTherapistId = destination.droppableId;

      // Check if this is a futureAdmission (draggableId starts with "future-")
      const isFutureAdmission = patientIdPart?.startsWith('future-');
      let patientId: string | null = null;
      let taskUuid: string | null = null;

      if (isFutureAdmission) {
        // Extract taskUuid from "future-{taskUuid}"
        taskUuid = patientIdPart?.replace('future-', '') || null;
      } else {
        patientId = patientIdPart;
      }

      // Check if the patient is an outpatient (only for non-futureAdmission)
      const sourceTherapist = therapistListState?.find(
        (therapist: any) => therapist?.uuid === sourceTherapistId
      );
      const patient = !isFutureAdmission
        ? sourceTherapist?.assignedPatients?.[patientId || '']
        : null;
      const isOutPatient = patient?.isOutPatient === true;

      if (isOutPatient && patientId) {
        // Find destination therapist
        const destinationTherapist = therapistListState?.find(
          (therapist: any) => therapist?.uuid === destinationTherapistId
        );

        if (destinationTherapist) {
          // Get taskUuid from appointments for unprocessedData
          const appointmentTaskUuid = patient?.appointments?.[0]?.taskUuid || patientId;

          // Check if recurringAppointmentUuid is present
          const hasRecurringAppointmentUuid = !!patient?.recurringAppointmentUuid;

          // Construct patient data for the modal
          const patientData = {
            ...patient,
            patientId: patientId,
            patientUuid: patientId,
            uuid: patientId,
            sourceTherapistId: sourceTherapistId,
            destinationTherapistId: destinationTherapistId,
            sourceTherapist: sourceTherapist,
            destinationTherapist: destinationTherapist,
            appointments: patient?.appointments || [],
            taskUuid: appointmentTaskUuid,
            taskId: appointmentTaskUuid,
          };

          setAppointmentPatient(patientData);
          setAppointmentTherapist(destinationTherapist);
          setMigrateRecurring(hasRecurringAppointmentUuid);
          setOpenAppointmentModal(true);
        }
        return;
      }

      // For futureAdmissions, use therapistMigrateTaskAction instead of migrateTherapisPatientAction
      if (isFutureAdmission && taskUuid) {
        const selectedTaskForDrop = sourceTherapistId;
        setTherapistIdToDrop(destination.droppableId);
        const allTherapistListData = [...therapistListState];
        const sourcePage = getTherapistPageNumber(allTherapistListData, selectedTaskForDrop);
        const destinationPage = getTherapistPageNumber(
          allTherapistListData,
          destination.droppableId
        );

        dispatch(
          therapistMigrateTaskAction({
            providerId,
            currentDate: selectedDate
              ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : '',
            sourceTherapist: sourceTherapistId,
            targetTherapist: destinationTherapistId,
            filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
            taskId: taskUuid,
            singleAssign: true,
            meta: meta,
            sourcePage: sourcePage,
            destinationPage: destinationPage,
            isV2: true,
          })
        );
        return;
      }

      const selectedTaskForDrop = sourceTherapistId;
      setTherapistIdToDrop(destination.droppableId);
      const allTherapistListData = [...therapistListState];
      const sourcePage = getTherapistPageNumber(allTherapistListData, selectedTaskForDrop);
      const destinationPage = getTherapistPageNumber(allTherapistListData, destination.droppableId);

      // Reassign all of the patient's tasks (individual + group + concurrent)
      // in one call. Per Ido: no confirmation popup on mixed task types.
      const migratePayload: any = {
        providerId,
        assignDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        sourceTherapist: sourceTherapistId,
        targetTherapist: destinationTherapistId,
        filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
        singleAssign: true,
        meta: meta,
        sourcePage: sourcePage,
        destinationPage: destinationPage,
        isV2: true,
      };
      if (patientId && patientId !== null && patientId !== undefined) {
        migratePayload.patientId = patientId;
      }
      dispatch(migrateTherapisPatientAction(migratePayload));
      return;
    }

    const addToTaskId = destination.droppableId;
    const selectedTaskForDrop = result.draggableId;
    const destinationAssignPage = getTherapistPageNumber(
      therapistListState,
      destination.droppableId
    );
    if (source.droppableId === destination.droppableId) {
      return;
    }

    // THIN-7718: honour the checkbox selection only when the task actually being dragged
    // is part of it, and only for tasks still present in the visible queue. Previously any
    // non-empty selection replaced the dragged task outright, so dragging an unselected
    // task assigned the stale selection instead of what the user picked up — and uuids
    // that had scrolled out or been filtered away were still sent. That is what produced
    // the multi-task assignment bursts sharing a single timestamp.
    const visibleTaskUuids = new Set((taskListState || []).map((task: any) => task?.uuid));
    const selectedAndVisible =
      taskSelectedId.length > 0 && taskSelectedId.includes(selectedTaskForDrop)
        ? taskSelectedId.filter((uuid: any) => visibleTaskUuids.has(uuid))
        : [];
    // Never end up with an empty payload — fall back to just the dragged task.
    const uuidsToAssign =
      selectedAndVisible.length > 0 ? selectedAndVisible : [selectedTaskForDrop];

    setTherapistIdToDrop(addToTaskId);
    setAssignTaskPage(destinationAssignPage);
    dispatch(
      therapistAssignTaskAction({
        providerId,
        therapistId: addToTaskId,
        searchData: searchData,
        date: selectedDate,
        currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
        refresh: false,
        meta: meta,
        destinationAssignPage: destinationAssignPage,
        data: {
          wantToGroup: false,
          unprocessedData: uuidsToAssign,
          processedData: [],
          groupUuid: null,
        },
        isV2: true,
        toPick: true,
      })
    );
  };

  const [infoMessage, setInfoMessage] = useState<InitialStateOfInfoModal>(initialStateOfInfoModal);
  const [dragAndDropData, setDragAndDropData] = useState<any>(null);

  const handleInfoMessageClose = () => {
    setInfoMessage(initialStateOfInfoModal);
  };

  const handleInfoMessageModal = () => {
    setInfoMessage(initialStateOfInfoModal);
    dragAndDropProcessing(dragAndDropData);
  };

  const handleScheduleAppointment = (assignedPatientUuid?: string) => {
    setOpenAppointmentModal(false);
    setSuccessFullRequest(true);
    setSuccessModalTitle({
      title: 'Success',
      message: 'Appointment scheduled successfully',
    });

    // Drop the just-assigned task from the queue immediately. The merge effect
    // on patientCard only deduplicates and never removes, so without this the
    // assigned task lingers in taskListState until manual page refresh.
    if (assignedPatientUuid) {
      setTasklistState((prev: any[]) =>
        (prev || []).filter((task: any) => task?.uuid !== assignedPatientUuid)
      );
    }

    getTherapistAndTask();
  };

  const handleCloseAppointmentModal = () => {
    setOpenAppointmentModal(false);
    setAppointmentPatient(null);
    setAppointmentTherapist(null);
    setMigrateRecurring(false);
  };

  const handleDragDrop = (result: any) => {
    if (isDragTerminated) {
      setIsDragTerminated(false);
      return;
    }
    if (!updateDailyTasks || !readDailyTasks) return;
    setDragged(false);
    setDraggedId('');
    const { source, destination, draggableId } = result;
    if (!destination) return;
    if (source.droppableId === destination.droppableId && source.index === destination.index)
      return;

    let isSupervisor: boolean | undefined;
    if (draggableId.includes('~') && source.droppableId !== destination?.droppableId) {
      const patientId = draggableId.split('~')[0];
      const isReassignedTherapist = therapistListState?.find(
        (item: any) => item?.uuid === source?.droppableId
      );
      isSupervisor = isReassignedTherapist?.assignedPatients?.[patientId]?.isSupervisorRequired;
    }

    if (draggableId.includes('+') && source.droppableId !== destination.droppableId) {
      isSupervisor = draggableId.split('+')[2] ? JSON?.parse(draggableId.split('+')[2]) : false;
    }

    const dragItem = taskListState?.find((item: any) => item?.uuid === draggableId);
    const dropOnItem = therapistListState?.find(
      (item: any) => item?.uuid === destination.droppableId
    );

    const multipleTask = taskListState?.filter((item) => taskSelectedId?.includes(item?.uuid));
    const isAnySupervisorRequired =
      multipleTask?.some((task) => !!task?.isSupervisorRequired) ?? false;

    // THIN-7718: last line of defence — never send an assignment whose task discipline
    // does not match the therapist it is being dropped on. The stale-response guards on
    // the two merge effects above are the actual fix; this catches any other path that
    // manages to get an off-discipline row on screen. Without it the backend happily
    // bound e.g. an OT task to a PT therapist, which then vanished from the OT queue
    // while sitting on a board no OT would ever look at.
    if (dropOnItem?.discipline) {
      // Mirror the payload logic in dragAndDropProcessing: the selection only counts when
      // the dragged task belongs to it, otherwise just the dragged task is sent.
      const assignedFromQueue =
        taskSelectedId.length > 0 && taskSelectedId.includes(draggableId)
          ? multipleTask ?? []
          : dragItem
          ? [dragItem]
          : [];
      const isCrossDisciplineAssign =
        source.droppableId === 'ROOT' &&
        assignedFromQueue.some((task: any) =>
          isDisciplineMismatch(task?.discipline, dropOnItem?.discipline)
        );
      // Therapist-to-therapist moves: both columns are scoped to a single discipline, so
      // source and destination therapists disagreeing means one column is showing stale
      // rows and the move would cross disciplines.
      const sourceTherapistForDrag =
        source.droppableId !== 'ROOT'
          ? therapistListState?.find((item: any) => item?.uuid === source.droppableId)
          : null;
      const isCrossDisciplineMigration = isDisciplineMismatch(
        sourceTherapistForDrag?.discipline,
        dropOnItem?.discipline
      );

      if (isCrossDisciplineAssign || isCrossDisciplineMigration) {
        setPopUpMessage({
          message:
            'This task belongs to a different discipline than the selected therapist. Refresh the scheduler and try again.',
          type: 'ERROR',
        });
        setTimeout(() => {
          setPopUpMessage({ message: '', type: '' });
        }, 3000);
        setDragAndDropData(null);
        return;
      }
    }

    if (
      (!!dragItem?.isSupervisorRequired || isAnySupervisorRequired || isSupervisor) &&
      dropOnItem?.roleName === 'assistant'
    ) {
      setInfoMessage({
        message: 'This treatment should be assigned to a therapist for supervision.',
        type: 'SUPERVISION_ALERT',
        title: 'Supervision required',
      });
      setDragAndDropData(result);
      return;
    }
    dragAndDropProcessing(result);
    setDragAndDropData(null);
  };

  const handleOpenAddTaskForm = () => {
    setSelectedPatientTask('');
    setSelectedTaskSource('');
    setOpenAddTaskForm(true);
  };

  const handleOpenAddTaskFormFromList = (patient: any) => {
    setSelectedPatientTask(patient);
    setSelectedTaskSource('ALERT_TASK');
    setOpenAddTaskForm(true);
  };

  const handleCloseAddTaskForm = () => {
    setOpenAddTaskForm(false);
  };

  const handleEditTimeDialog = () => {
    setOpenEditTimeDialog((prev) => !prev);
  };

  function isString(value: any) {
    return typeof value === 'string';
  }

  const DeleteTherapistPatient = (therapistId: string, taskSchedulingData: any) => {
    reloadUpToPageRef.current = patientTaskPageNo;
    // Do NOT optimistically clear taskListState here. On API failure the cleared
    // state is never restored, which misleads the user into thinking the delete
    // succeeded when the backend rejected it. The unassign response carries
    // addedTaskUuids and the refresh chain will pull in the full data.
    // Suppress the auto-fetch that the patientTaskPageNo change would trigger
    // (saga + post-success effect cover the refresh, see dragAndDropProcessing).
    if (patientTaskPageNo > 0) {
      skipNextTaskFetchRef.current = true;
    }
    setPatientTaskPageNo(0);
    setTherapistListPageNo(0);

    setMeta({
      providerId,
      type: selectedTaskType?.length ? selectedTaskType : [],
      active: true,
      discipline: currentTab ? currentTab : '',
      date: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
      skill: currentSkillSelected ? currentSkillSelected : '',
      sortBy: selectedSortType ? selectedSortType : '',
      taskPage: 0,
      therapistPage: 0,
      filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
    });
    dispatch(
      therapistAssignUndoAction({
        providerId,
        type: selectedTaskType?.length ? selectedTaskType : [],
        active: true,
        searchData,
        currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',

        filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
        meta: {
          providerId,
          type: selectedTaskType?.length ? selectedTaskType : [],
          active: true,
          discipline: currentTab ? currentTab : '',
          date: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          skill: currentSkillSelected ? currentSkillSelected : '',
          sortBy: selectedSortType ? selectedSortType : '',
          taskPage: 0,
          therapistPage: 0,
        },
        discipline: currentTab ? currentTab : '',
        date: selectedDate,
        skill: currentSkillSelected ? currentSkillSelected : '',
        sortBy: selectedSortType ? selectedSortType : '',
        therapistId: therapistId ? therapistId : '',
        taskType: taskSchedulingData.groupUuid ? 'group-uuid' : 'task-uuid',
        taskId: taskSchedulingData.groupUuid
          ? taskSchedulingData.groupUuid
          : taskSchedulingData.taskUuids,
        requestBody: {
          taskUuids: !taskSchedulingData.groupUuid
            ? isString(taskSchedulingData.taskUuids)
              ? [taskSchedulingData.taskUuids]
              : taskSchedulingData.taskUuids
            : null,
          groupUuid: taskSchedulingData.groupUuid ? taskSchedulingData.groupUuid : null,
        },
        isV2: true,
      })
    );
  };

  const handleCloseInfo = () => {
    setOpenModal(false);
    setMigratePatientData('');
  };

  const handleCloseDialog = () => {
    setUnAssignPatientData({});
    setOpenDialog(false);
  };

  const handleChangeDate = (e: any) => {
    abortControllerRef?.current?.abort();
    abortControllerPatinetListRef?.current?.abort();
    const originalDate = new Date(e);
    const day = originalDate.getDate().toString().padStart(2, '0');
    const month = (originalDate.getMonth() + 1).toString().padStart(2, '0');
    const year = originalDate.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    if (formattedDate !== selectedDate) {
      setPatientTaskShowMainLoader(true);
      setTherapistTaskMainLoader(true);
      setTasklistState([]);
      setTherapistListState([]);
      setPatientTaskPageNo(0);
      setTherapistListPageNo(0);
      setSelectedDate(formattedDate);
      setTaskSelectedId([]);
      setOpenCalender(false);
    } else {
      setOpenCalender(false);
    }
  };

  const closeSuccessModal = () => {
    setSuccessFullRequest(false);
  };

  const handleClickCalender = () => {
    setOpenCalender((prev) => !prev);
  };

  const getRightSideList = () => {
    setTherapistListPageNo(0);
    dispatch(
      getAllTherapistListAction({
        pageNo: 0,
        data: {
          providerId,
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          discipline: currentTab ? currentTab : '',
          sortBy: selectedSortType ? selectedSortType : '',
          searchData,
          filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
          isV2: true,
        },
      })
    );
  };

  const getLeftSideList = () => {
    setTasklistState([]);
    setPatientTaskPageNo(0);

    dispatch(
      disableAutoMatchAction({
        providerId,
        discipline: currentTab ? currentTab : '',
        currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
      })
    );
    dispatch(
      getAllTherapistTaskAction({
        pageNo: 0,
        data: {
          type: selectedTaskType?.length ? selectedTaskType : [],
          active: true,
          discipline: currentTab ? currentTab : '',
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          providerId,
          skill: currentSkillSelected ? currentSkillSelected : '',
          isV2: true,
        },
      })
    );
    dispatch(
      getAllTherapistDiciplineAction({
        providerId,
        localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        data: {
          isV2: true,
        },
      })
    );
  };

  const handleEditTime = (isAssigned?: any) => {
    dispatch(resetEditTaskTimeAction());

    if (typeof isAssigned === 'boolean') {
      // Only do one side depending on the value
      if (isAssigned) {
        getRightSideList();
      } else {
        getLeftSideList();
      }
    } else {
      // If isAssigned is undefined, do everything
      getRightSideList();
      getLeftSideList();
    }
  };

  const getTherapistAndTask = () => {
    dispatch(
      getAllTherapistTaskAction({
        pageNo: patientTaskPageNo,
        data: {
          type: selectedTaskType?.length ? selectedTaskType : [],
          active: true,
          discipline: currentTab ? currentTab : '',
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          providerId,
          skill: currentSkillSelected ? currentSkillSelected : '',
          isV2: true,
        },
      })
    );
    dispatch(
      getAllTherapistListAction({
        pageNo: therapistListPageNo,
        data: {
          providerId,
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          discipline: currentTab ? currentTab : '',
          sortBy: selectedSortType ? selectedSortType : '',
          signal: abortControllerRef.current.signal,
          searchData,
          filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
          isV2: true,
        },
      })
    );
  };

  const handleToRescheduleTask = (task: any) => {
    setSelectedPatient(task?.patientLastname + ' ' + task?.patientFirstname);
    setReSchedulingTaskDate(new Date(task?.localDate));

    if (
      task?.tasksType === 'GROUP_THERAPY' ||
      task?.tasksType === 'CONCURRENT' ||
      (task?.tasksType === 'THERAPY' && task?.source != 'PREADMIT')
    ) {
      setInfoTitle('Reschedule therapy task');
      setOpenModal(true);
      return;
    } else {
      setSelectedReSchedulingTask(task);
      setReSchedulingTask(true);
      return;
    }
  };

  const handleSaveBtn = () => {
    if (migratePatientData) {
      dispatch(migrateTherapisPatientAction(migratePatientData));
      setMigratePatientData('');
      setOpenModal(false);
      return;
    }

    navigate('/scheduling/therapy-planning/details/info', {
      state: {
        patientId: selectedPatient,
        searchData: selectedPatient,
      },
    });
  };

  const handleUnassignConfirm = () => {
    patientUnAssign(unAssignPatientData?.patientId, unAssignPatientData?.therapistId);
    setUnAssignPatientData({});
    setOpenDialog(false);
  };

  const handleSelectDate = (date: any) => {
    const calenderDateSelected = moment(date).format('DD-MM-YYYY');
    const newTaskType = taskType?.find(
      (res: any) => res?.key === selectedReSchedulingTask?.tasksType
    );

    setPatientTaskShowMainLoader(true);
    if (Object.keys(selectedReSchedulingTask)?.length !== 0) {
      dispatch(
        editTaskTherapistSchedulingAction({
          providerId,
          date: selectedDate ? selectedDate : '',
          currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          // THIN-7718: the board's discipline, used only for the follow-up task-list
          // refetch. Kept separate from data.discipline below, which is part of the edit
          // request body and must stay the task's own discipline.
          refetchDiscipline: currentTab ? currentTab : '',

          data: {
            uuid: selectedReSchedulingTask?.uuid,
            selectedTaskType: selectedTaskType,
            localDate: calenderDateSelected,
            tasksType: newTaskType?.key,
            numberOfMinutes: selectedReSchedulingTask?.numberOfMinutes,
            description: selectedReSchedulingTask?.description,
            patientId: selectedReSchedulingTask?.patientUuid,
            discipline: selectedReSchedulingTask?.discipline,
            pageNo: patientTaskPageNo,
            isV2: true,
          },
        })
      );
      // setTasklistState(
      //   taskListState.filter((item: any) => item.uuid !== selectedReSchedulingTask?.uuid)
      // );
    } else {
      setReSchedulingTask(false);
    }
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalInfo((prevState: any) => ({ ...prevState, open: false }));
    setTimeout(() => {
      setDeleteModalInfo({
        message: '',
        saveLabel: '',
        closeLabel: '',
        title: '',
        deleteType: '',
        uuid: '',
      });
    }, 100);
  };

  const setOpenTaskDeleteModal = (patient: any) => {
    if (patient?.splitRef) {
      setDeleteModalInfo({
        open: true,
        message:
          ' This will delete the selected split task and attribute the entire session duration to the remaining task. ',
        saveLabel: 'Delete Task',
        closeLabel: 'Cancel',
        title: 'Delete a Split Task',
        deleteType: 'DELETE_SPLIT_TASK',
      });
      return;
    }
    setDeleteModalInfo({
      open: true,
      message: 'Are you sure you want to delete this task?',
      saveLabel: 'Delete Task',
      closeLabel: 'Cancel',
      title: 'Delete Task',
      deleteType: 'DELETE_TASK',
    });
  };

  const handleOpenDeleteAnnounceModal = (announceUuid: string) => {
    setOpenAnnounceDialog(false);
    setDeleteModalInfo({
      open: true,
      message: 'Are you sure you want to delete this announcement?',
      saveLabel: 'Delete announcement',
      closeLabel: 'Cancel',
      title: 'Delete Announcement',
      deleteType: 'DELETE_ANNOUNCEMENT',
      uuid: announceUuid,
    });
  };

  const handleOpenDeleteTaskNote = () => {
    setIsTaskNote(false);
    setDeleteModalInfo({
      open: true,
      message: 'Are you sure you want to delete this note?',
      saveLabel: 'Delete note',
      closeLabel: 'Cancel',
      title: 'Delete note',
      deleteType: 'DELETE_NOTE',
    });
  };

  const handleDeleteBtn = () => {
    if (deleteModalInfo.deleteType === 'DELETE_TASK') {
      dispatch(
        deletePatientTask({
          providerId,
          taskId: currentPatientTask,
        })
      );
    } else if (deleteModalInfo.deleteType === 'DELETE_NOTE') {
      dispatch(
        deleteTherapistTaskNoteAction({
          providerId: providerId,
          taskId: currentPatientTask,
        })
      );
    } else if (deleteModalInfo.deleteType === 'DELETE_ANNOUNCEMENT') {
      dispatch(
        deleteAnnouncementAction({
          uuid: deleteModalInfo?.uuid,
        })
      );
    } else if (deleteModalInfo?.deleteType === 'DELETE_SPLIT_TASK') {
      dispatch(
        deleteSplitTaskAction({
          therapistId: providerId,
          taskUuid: currentPatientTask,
        })
      );
    }
    handleCloseDeleteModal();
  };

  const handleCloseTaskNote = useCallback(() => {
    setIsTaskNote(false);
  }, []);

  const handleOpenTaskNote = useCallback(() => {
    setIsTaskNote(true);
  }, []);

  const handleScroll = useCallback(
    (event: any) => {
      const scrollThreshold = 0.8;

      if (
        Math.abs(
          (event.target as any).scrollHeight -
            (event.target as any).scrollTop -
            (event.target as any).clientHeight
        ) <= scrollThreshold
      ) {
        if (
          !therapistList?.last &&
          !isLoadingTherapistList &&
          therapistListState.length < therapistList?.totalElements
        ) {
          setTherapistTaskMainLoader(false);
          setTherapistListPageNo(therapistListPageNo + 1);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isLoadingTherapistList, therapistListPageNo]
  );

  const openAnnouncementDialog = () => {
    dispatch(
      getAllAnnouncementsAction({
        selectedDate: moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
      })
    );
    setOpenAnnounceDialog(true);
  };

  const handlecloseAnnounceDialog = () => {
    setOpenAnnounceDialog(false);
    dispatch(resetGetAllAnnouncementsAction());
  };

  const handleSpitTask = (patient: any) => {
    setSplitMinPatient(patient);
    setSourceOfSplitMin('ADD_SPLIT_MIN');
    setOpenSplitMin(true);
  };

  const handleContinueSplitMin = (splitMin: SplitMinutes) => {
    dispatch(
      getSplitTaskMinAction({
        providerId,
        data: {
          splitMinute: splitMin.task2Minutes,
          taskUuid: splitMin.uuid,
        },
      })
    );
  };

  const editUnassignedTaskMin = (patient: any) => {
    if (patient?.splitRef) {
      dispatch(
        getSplitTaskAction({
          therapistId: providerId,
          taskUuid: patient?.uuid,
        })
      );
      setSplitMinPatient(patient);
      setSourceOfSplitMin('EDIT_SPLIT_MIN');
      setOpenSplitMin(true);
      return;
    } else {
      setOpenEditTimeDialog(true);
      setTherapyInfo({
        taskId: patient?.uuid,
        therapyType: patient?.tasksType,
        taskType: 'task-uuid',
        numberOfMinutes: patient?.numberOfMinutes,
        isAssigned: false,
      });
    }
  };

  const editAssignedTaskMin = (patient: any) => {
    setSplitMinPatient(patient);
    setSourceOfSplitMin('EDIT_SPLIT_MIN');
    setOpenSplitMin(true);
  };

  return (
    <>
      <Seo title="Restore-Insights: Patient" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // py: 5,
        }}
      >
        <Container maxWidth={false}>
          <Stack spacing={2}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent={'space-between'}
            >
              <Stack
                direction="row"
                alignItems="center"
                spacing={3}
              >
                <Stack gap="1rem">
                  <Typography
                    variant="h4"
                    data-testid={schedulingTestId('board-heading')}
                  >
                    Daily Therapist Scheduling
                  </Typography>
                </Stack>
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={4}
                >
                  <Tabs
                    indicatorColor="primary"
                    onChange={handleTabsChange}
                    scrollButtons="auto"
                    textColor="primary"
                    value={currentTab}
                    variant="scrollable"
                  >
                    {therapistTabs &&
                      therapistTabs?.map((tab: any) => (
                        <Tab
                          key={tab.key}
                          label={
                            <span>
                              <span>{tab.key}</span>
                              <Chip
                                sx={{ cursor: 'pointer', marginLeft: '10px', color: '#6C737F' }}
                                label={tab.count}
                                size="small"
                              />
                            </span>
                          }
                          value={tab.key}
                        />
                      ))}
                  </Tabs>
                </Stack>
                <Stack ref={calenderRef}>
                  <Button
                    sx={{
                      background: '#fff',
                      borderRadius: '12px',
                      border: '1px solid rgba(17, 25, 39, 0.16)',
                      color: '#384250',
                      '&:hover': {
                        border: '1px solid rgba(17, 25, 39, 0.16)',
                      },
                    }}
                    startIcon={
                      <SvgIcon>
                        <CalendarToday />
                      </SvgIcon>
                    }
                    variant="outlined"
                    onClick={handleClickCalender}
                  >
                    {formattedDate} {moment(jsDate).isSame(currentDate, 'day') && '(Today)'}
                  </Button>
                  {openCalender && (
                    <BasicDateCalendar
                      value={selectedDate}
                      handleChangeDate={handleChangeDate}
                    />
                  )}
                </Stack>
                {canAddAnnouncement && (
                  <Stack>
                    <IconButton
                      sx={{ height: '40px' }}
                      onClick={openAnnouncementDialog}
                    >
                      <AnnouncementIcon />
                    </IconButton>
                  </Stack>
                )}
                <Tooltip
                  title={
                    canPrintBulkSchedule
                      ? "Print everyone's schedules"
                      : 'No tasks are assigned to any therapist'
                  }
                >
                  <span>
                    <IconButton
                      sx={{
                        height: '36px',
                        width: '61px',
                        color: '#6366F1',
                        border: '1px solid rgba(99, 102, 241, 0.6)',
                        borderRadius: '12px',
                      }}
                      onClick={() => setIsBulkPrintOpen(true)}
                      disabled={!canPrintBulkSchedule}
                    >
                      <Print />
                    </IconButton>
                  </span>
                </Tooltip>
              </Stack>
              <Stack
                flexDirection={'row'}
                alignItems={'center'}
              >
                <PayerColorLegend />
              </Stack>
            </Stack>

            <Stack
              direction="row"
              spacing={{
                xs: 2,
                lg: 3,
              }}
              sx={{ width: '100%' }}
            >
              <DragDropContext
                onDragEnd={handleDragDrop}
                onDragStart={(e) => {
                  setIsDragTerminated(false);
                  setDragged(true);
                  setDraggedId(e.draggableId);
                }}
              >
                <Stack
                  sx={{
                    // Fixed budget the patients panel is laid out against: 40% of the content,
                    // clamped 440–700. It never shrinks — the therapists panel yields instead.
                    width: '40%',
                    display: 'flex',
                    maxWidth: '700px !important',
                    minWidth: '440px',
                    flexShrink: 0,
                    flexDirection: 'column',
                    gap: '1rem',
                  }}
                >
                  <Droppable droppableId="ROOT">
                    {(provided, snapshot) => (
                      <Stack
                        {...provided.droppableProps}
                        ref={(el) => {
                          provided.innerRef(el);
                          patientPanelRef.current = el;
                        }}
                        id="patientTask"
                        data-testid={schedulingTestId('task-pool')}
                        sx={{
                          borderRadius: '15px',
                          background: snapshot.isDraggingOver ? '#e0f0ff' : '#F3F4F6 !important',
                          height: '82vh',
                          // Never scroll sideways: an over-wide row wraps or clips instead.
                          overflowX: 'hidden',
                          overflowY: 'scroll',
                          '::-webkit-scrollbar': {
                            width: '5px',
                          },
                          border: snapshot.isDraggingOver ? '1px solid #007bff' : 'none',
                        }}
                      >
                        <div
                          style={{
                            position: 'sticky',
                            // Sizes to its content: the header row plus the filter row now exceed
                            // the old fixed 100px, which let the scrolling list run underneath.
                            height: 'auto',
                            top: 0,
                            backgroundColor: '#F3F4F6',
                            zIndex: 2,
                          }}
                        >
                          <Box
                            sx={{
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              flexWrap: 'wrap',
                              // gap: '8px',
                            }}
                          >
                            <Box
                              display="flex"
                              justifyContent="flex-start"
                              alignItems="center"
                              sx={{
                                padding: '8px 0px 0px 16px',
                                height: '55px',
                                borderBottom: '1px solid #D2D6DB',
                                width: '100%',
                              }}
                            >
                              <Typography
                                sx={{
                                  color: '#111927',
                                  fontFamily: 'Inter',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  lineHeight: '24px',
                                  letterSpacing: '0.5px',
                                }}
                              >
                                {'PATIENTS'}
                              </Typography>
                              <Chip
                                sx={{
                                  cursor: 'pointer',
                                  marginLeft: '10px',
                                  color: '#EEEEEE',
                                  '& .MuiChip-label': {
                                    whiteSpace: 'normal',
                                    fontSize: '13px',
                                    fontFamily: 'Inter',
                                    fontWeight: '500',
                                    lineHeight: '18px',
                                    letterSpacing: '0.16px',
                                    color: '#111927',
                                  },
                                }}
                                label={patientTotalElements || 0}
                                size="small"
                              />
                              <TextField
                                variant="outlined"
                                size="small"
                                placeholder="Search"
                                value={patientSearchInput}
                                onChange={(e: any) => setPatientSearchInput(e.target.value)}
                                hiddenLabel
                                inputProps={{ 'data-testid': schedulingTestId('task-search') }}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment
                                      position="start"
                                      sx={{ mr: 0.5 }}
                                    >
                                      <SearchIcon sx={{ fontSize: 18, color: '#6C737F' }} />
                                    </InputAdornment>
                                  ),
                                }}
                                sx={{
                                  ml: 1,
                                  // Takes whatever the row has left: 180 on a wide monitor, down
                                  // to 92 on a 13" panel where the count, Skills and + Add Task
                                  // need the room.
                                  flex: '1 1 92px',
                                  minWidth: 92,
                                  maxWidth: 180,
                                  alignSelf: 'center',
                                  '& .MuiOutlinedInput-root': {
                                    height: 32,
                                    borderRadius: '6px',
                                    backgroundColor: '#fff',
                                    pl: 1,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    py: 0,
                                    pr: 1,
                                    fontSize: 13,
                                  },
                                  '& .MuiOutlinedInput-input::placeholder': {
                                    fontSize: 13,
                                    opacity: 1,
                                    color: '#9CA3AF',
                                  },
                                }}
                              />
                              <Box sx={{ display: 'flex', ml: '6px' }}>
                                <SkillsMultiSelect
                                  label="Skills"
                                  options={getTherapistSkillListResponse || []}
                                  selectedValue={currentSkillSelected}
                                  resetVal={setCurrentSkillSelected}
                                  onChange={(e: any) => {
                                    setCurrentSkillSelected(e);
                                    setPatientTaskShowMainLoader(true);
                                    setPatientTaskPageNo(0);
                                    setTasklistState([]);
                                    setTaskSelectedId([]);
                                  }}
                                />
                              </Box>
                              <Box sx={{ display: 'flex', ml: '6px' }}>
                                <Button
                                  variant="text"
                                  onClick={handleOpenAddTaskForm}
                                  data-testid={schedulingTestId('add-task')}
                                  sx={{
                                    px: 1,
                                    fontFamily: 'Inter',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    lineHeight: '22px ',
                                    letterSpacing: '0.2px ',
                                    color: '#111927',
                                  }}
                                  disabled={!has(Permissions.CREATE_DAILY_TASK)}
                                >
                                  + Add Task
                                </Button>
                              </Box>
                            </Box>

                            {
                              <Box
                                sx={{
                                  display: 'flex',
                                  // Budgeted to hold one line on a 440px panel (the 13" floor of
                                  // the 40% width below). Should a platform's font metrics still
                                  // overflow, the grid drops to a second line rather than the
                                  // panel growing a horizontal scrollbar.
                                  flexWrap: 'wrap',
                                  minHeight: '55px',
                                  padding: '8px 0px 0px 16px',
                                }}
                              >
                                <Box sx={{ display: 'flex', flexDirection: 'column', mr: '16px' }}>
                                  {TIME_BASIS_OPTIONS.map((option) => (
                                    <FormControlLabel
                                      key={option.value}
                                      control={
                                        <Radio
                                          size="small"
                                          checked={timeBasis === option.value}
                                          onChange={() => handleTimeBasisChange(option.value)}
                                          sx={{
                                            p: '2px',
                                            mr: '4px',
                                            '& .MuiSvgIcon-root': { fontSize: 18 },
                                          }}
                                        />
                                      }
                                      label={option.label}
                                      sx={{
                                        m: 0,
                                        '& .MuiFormControlLabel-label': {
                                          fontFamily: 'Inter',
                                          fontSize: '12px',
                                          fontWeight: 600,
                                          color: '#111927',
                                          whiteSpace: 'nowrap',
                                        },
                                      }}
                                    />
                                  ))}
                                </Box>
                                <Tooltip
                                  title={
                                    <Typography
                                      sx={{
                                        fontFamily: 'Inter',
                                        fontSize: '12px',
                                        lineHeight: '18px',
                                      }}
                                    >
                                      {TIME_BASIS_TOOLTIP[timeBasis]}
                                    </Typography>
                                  }
                                  placement="bottom"
                                  slotProps={{
                                    popper: {
                                      modifiers: [
                                        { name: 'offset', options: { offset: [20, -15] } },
                                      ],
                                    },
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                      <Typography
                                        sx={{
                                          color: '#111927',
                                          fontFamily: 'Inter',
                                          fontSize: '12px',
                                          fontWeight: '600',
                                          lineHeight: '24px',
                                          letterSpacing: '0.5px',
                                        }}
                                      >
                                        {`${Math.floor((basisSessionTime || 0) / 60)}:${String(
                                          (basisSessionTime || 0) % 60
                                        ).padStart(2, '0')} hr`}
                                      </Typography>
                                      {/* The total follows the task-type filter, so say so. */}
                                      {isTaskTypeFiltered ? (
                                        <Typography
                                          sx={{
                                            color: '#6C737F',
                                            fontFamily: 'Inter',
                                            fontSize: '11px',
                                            lineHeight: '14px',
                                          }}
                                        >
                                          (Filtered)
                                        </Typography>
                                      ) : null}
                                    </Box>
                                  </Box>
                                </Tooltip>
                                <Box
                                  sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, auto)',
                                    columnGap: '6px',
                                    alignItems: 'center',
                                    alignContent: 'center',
                                    ml: '4px',
                                    pl: '6px',
                                    borderLeft: '1px solid #D2D6DB',
                                  }}
                                >
                                  {TASK_TYPE_FILTERS.map((filter) => {
                                    const breakdown = (taskTypeBreakdown || []).find(
                                      (item: any) => item?.taskType === filter.breakdownKey
                                    );
                                    const isSelected = !!selectedTaskType?.includes(filter.key);
                                    // Nothing to filter by, so the box is inert — but never
                                    // disable one that is already ticked, or a type that drops to
                                    // zero after a date/discipline change would strand the list
                                    // on 0 results with no way to clear it.
                                    const isDisabled =
                                      !isSelected && !(breakdown?.sessionCount > 0);
                                    return (
                                      <Box
                                        key={filter.key}
                                        sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                                      >
                                        <Checkbox
                                          size="small"
                                          checked={isSelected}
                                          disabled={isDisabled}
                                          onChange={() => handleTaskTypeToggle(filter.key)}
                                          // The theme's checkbox glyphs are plain 24px SVGs, so
                                          // size="small" leaves them at 24 — shrink them directly.
                                          sx={{ p: '2px', '& svg': { width: 18, height: 18 } }}
                                        />
                                        <Typography
                                          sx={{
                                            fontFamily: 'Inter',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            color: isDisabled ? '#9DA4AE' : '#3f4145',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          {filter.label}
                                        </Typography>
                                        {breakdown ? (
                                          <Typography
                                            sx={{
                                              fontFamily: 'Inter',
                                              fontSize: '12px',
                                              fontWeight: 600,
                                              color: isDisabled ? '#9DA4AE' : '#111927',
                                            }}
                                          >
                                            {formatMinutesAsHours(
                                              timeBasis === 'LABOR'
                                                ? breakdown?.weightedMinutes
                                                : breakdown?.minutes
                                            )}
                                          </Typography>
                                        ) : null}
                                        {breakdown && !isPatientPanelNarrow ? (
                                          <Typography
                                            sx={{
                                              fontFamily: 'Inter',
                                              fontSize: '12px',
                                              color: '#9DA4AE',
                                            }}
                                          >
                                            {`(${breakdown.sessionCount ?? 0})`}
                                          </Typography>
                                        ) : null}
                                      </Box>
                                    );
                                  })}
                                </Box>
                              </Box>
                            }
                          </Box>
                        </div>
                        <div
                          style={{
                            display:
                              isLoadingTherapistTask && showPatientTaskMainLoader ? 'flex' : 'none',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            height: '48vh',
                          }}
                        >
                          <img
                            src={LoaderIcon}
                            alt="loader.."
                          />
                        </div>
                        {taskListState?.length == 0 ? (
                          <Box
                            sx={{
                              display:
                                isLoadingTherapistTask && showPatientTaskMainLoader
                                  ? 'none'
                                  : 'inherit',
                            }}
                            margin={'10px'}
                          >
                            All the patients have been assigned. Great work!
                          </Box>
                        ) : (
                          <InfiniteScroll
                            style={{
                              height: '100%',
                              display:
                                isLoadingTherapistTask && showPatientTaskMainLoader
                                  ? 'none'
                                  : 'inherit',
                              padding: '10px',
                              // The library defaults its wrapper to overflow: auto, which gives
                              // the list its own horizontal scrollbar whenever a card is wider
                              // than the panel. The panel (#patientTask) is the scroll target.
                              overflowX: 'hidden',
                            }}
                            dataLength={taskListState ? taskListState.length : 0}
                            next={() => {
                              setPatientTaskShowMainLoader(false);
                              setPatientTaskPageNo((prev) => prev + 1);
                            }}
                            scrollThreshold={'99%'}
                            hasMore={!isLastPatientList}
                            loader={
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  width: '100%',
                                }}
                              >
                                <img
                                  src={LoaderIcon}
                                  alt="loader.."
                                />
                              </div>
                            }
                            scrollableTarget={'patientTask'}
                          >
                            {taskListState
                              ?.slice()
                              .sort((a: any, b: any) => {
                                const aAlert = a?.alertType;
                                const bAlert = b?.alertType;
                                if (!aAlert && bAlert) return -1;
                                if (aAlert && !bAlert) return 1;

                                const lastNameCompare = (a?.patientLastname || '').localeCompare(
                                  b?.patientLastname || '',
                                  undefined,
                                  { sensitivity: 'base' }
                                );
                                if (lastNameCompare !== 0) return lastNameCompare;
                                return (a?.patientFirstname || '').localeCompare(
                                  b?.patientFirstname || '',
                                  undefined,
                                  { sensitivity: 'base' }
                                );
                              })
                              ?.map((patient: any, index: number) => {
                                return (
                                  <Draggable
                                    draggableId={patient.uuid}
                                    key={patient?.uuid}
                                    index={index}
                                    isDragDisabled={patient?.alertType === 'TASK_ALERT'}
                                  >
                                    {(provided, snapshot) => (
                                      <Box
                                        {...provided.dragHandleProps}
                                        {...provided.draggableProps}
                                        ref={provided.innerRef}
                                        data-testid={taskTestId(patient?.uuid)}
                                      >
                                        <Table>
                                          <TableBody
                                            sx={{
                                              display: {
                                                md: 'flex',
                                                lg: 'flex',
                                                sm: 'flex',
                                                xs: 'flex',
                                              },
                                              position: 'relative',
                                              width: dragged
                                                ? 'initial'
                                                : matches
                                                ? '100%'
                                                : 'initial',
                                            }}
                                          >
                                            <TableRow
                                              sx={{
                                                borderRadius: '12px',
                                                display:
                                                  dragged &&
                                                  taskSelectedId.includes(patient.uuid) &&
                                                  taskSelectedId.includes(draggedId) &&
                                                  draggedId !== patient.uuid
                                                    ? 'none'
                                                    : 'flex',
                                                width: '100%',
                                                height: { lg: 'auto', md: 'auto', sm: 'auto' },
                                                margin: '6px 0px',
                                                padding: '.6rem 0',
                                                alignItems: 'flex-start',
                                                justifyContent: 'space-between',
                                                background: snapshot.isDragging
                                                  ? '#EBEEFE'
                                                  : '#FFF',
                                                boxShadow: '0px 1px 10px 0px rgba(0, 0, 0, 0.08)',
                                              }}
                                            >
                                              <td>
                                                <Stack
                                                  className="store-container"
                                                  direction="row"
                                                  textAlign={'center'}
                                                  sx={{
                                                    width: '100%',
                                                    borderRadius: '12px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    pointerEvents:
                                                      !updateDailyTasks || !readDailyTasks
                                                        ? 'none'
                                                        : 'inherit',
                                                  }}
                                                >
                                                  <TherapistTaskList
                                                    handleToRescheduleTask={handleToRescheduleTask}
                                                    setOpenTaskDeleteModal={setOpenTaskDeleteModal}
                                                    setCurrentPatientTask={setCurrentPatientTask}
                                                    patient={patient}
                                                    setTaskSelectedId={setTaskSelectedId}
                                                    taskSelectedId={taskSelectedId}
                                                    handleOpenTaskNote={handleOpenTaskNote}
                                                    setIsEditNote={setIsEditNote}
                                                    handleOpenAddTaskFormFromList={
                                                      handleOpenAddTaskFormFromList
                                                    }
                                                    handleSpitTask={handleSpitTask}
                                                    editUnassignedTaskMin={editUnassignedTaskMin}
                                                    selectedDate={
                                                      selectedDate
                                                        ? moment(selectedDate, 'DD-MM-YYYY').format(
                                                            'YYYY-MM-DD'
                                                          )
                                                        : ''
                                                    }
                                                  />
                                                  {dragged &&
                                                    taskSelectedId.includes(patient.uuid) &&
                                                    taskSelectedId.length > 1 && (
                                                      <Box
                                                        sx={{
                                                          background: 'red',
                                                          borderRadius: '50%',
                                                          width: '20px',
                                                          height: '20px',
                                                          padding: '2px',
                                                          display: 'flex',
                                                          justifyContent: 'center',
                                                          alignItems: 'center',
                                                          color: 'white',
                                                          position: 'absolute',
                                                          right: '-2px',
                                                          top: '6px',
                                                        }}
                                                      >
                                                        {taskSelectedId.length}
                                                      </Box>
                                                    )}
                                                </Stack>
                                              </td>
                                            </TableRow>
                                          </TableBody>
                                        </Table>
                                      </Box>
                                    )}
                                  </Draggable>
                                );
                              })}
                          </InfiniteScroll>
                        )}

                        {provided.placeholder}
                      </Stack>
                    )}
                  </Droppable>
                </Stack>

                <Stack
                  sx={{
                    // Takes whatever the patients panel leaves. A fixed 68% next to a 40% panel
                    // summed past 100% and made the whole row scroll sideways on 13" screens.
                    flex: '1 1 0',
                    minWidth: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                  }}
                >
                  <Stack
                    id="therapistId"
                    data-testid={schedulingTestId('therapist-columns')}
                    sx={{
                      borderRadius: '15px',
                      background: '#F3F4F6 !important',
                      height: '82vh',
                    }}
                  >
                    <div
                      style={{
                        position: 'sticky',
                        // minHeight: '48px',
                        height: 'auto',
                        top: 0,
                        backgroundColor: '#F3F4F6 ',
                        zIndex: 2,
                        borderRadius: '15px 15px 0px 15px',
                      }}
                    >
                      <Box
                        sx={{
                          padding: '8px 16px 0px 16px',
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          flexWrap: 'wrap',
                          // gap: '16px',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            height: '40px',
                            gap: '8px',
                            width: lgdown ? '100%' : '50%',
                          }}
                        >
                          <Box
                            display={'flex'}
                            alignItems={'center'}
                          >
                            <Typography
                              sx={{
                                color: '#111927 !important',
                                fontFamily: 'Inter !important',
                                fontSize: '12px !important',
                                fontStyle: 'normal !important',
                                fontWeight: '600 !important',
                                lineHeight: '24px !important',
                                letterSpacing: '0.5px !important',
                              }}
                            >
                              {'THERAPISTS'}
                            </Typography>
                            <Chip
                              sx={{
                                cursor: 'pointer',
                                marginLeft: '10px',
                                color: '#EEEEEE',
                                '& .MuiChip-label': {
                                  whiteSpace: 'normal',
                                  fontSize: '13px ',
                                  fontFamily: 'Inter ',
                                  fontWeight: '500',
                                  lineHeight: '18px ',
                                  letterSpacing: '0.16px ',
                                  color: '#111927',
                                },
                              }}
                              label={therapistList?.totalElements || 0}
                              size="small"
                            />
                          </Box>
                          <Tooltip
                            title="Total available time"
                            placement="bottom"
                            slotProps={{
                              popper: {
                                modifiers: [{ name: 'offset', options: { offset: [20, -20] } }],
                              },
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                ml: 1,
                                pl: 1,
                                borderLeft: '2px solid #D2D6DB',
                              }}
                            >
                              <AccessTime sx={{ fontSize: '16px', color: '#111927' }} />
                              <Typography
                                sx={{
                                  color: '#111927',
                                  fontFamily: 'Inter',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  lineHeight: '24px',
                                  letterSpacing: '0.5px',
                                }}
                              >
                                {`${Math.floor(
                                  (therapistList?.totalSessionTime || 0) / 60
                                )}:${String((therapistList?.totalSessionTime || 0) % 60).padStart(
                                  2,
                                  '0'
                                )} hr`}
                              </Typography>
                            </Box>
                          </Tooltip>
                          <Box>
                            <MultiSelectPatientList
                              data-testid={schedulingTestId('therapist-filter')}
                              label="Therapist"
                              options={
                                patientDisciplineList?.map((list: any) => {
                                  return {
                                    label: list[1],
                                    id: list[0],
                                  };
                                }) || []
                              }
                              selectedValue={filterTherapistList}
                              setTherapistListPageNo={setTherapistListPageNo}
                              appliedvalues={filterTherapistList?.length}
                              currentTab={currentTab}
                              onChange={(list: any) => {
                                setIsMaintainFilterAvailable(false);
                                setTherapistListPageNo(0);
                                dispatch(
                                  maintainTherapistFilterAction(list, currentTab, providerId)
                                );
                                // setFilterTherapistList(list);
                              }}
                            />
                          </Box>
                        </Box>

                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            height: '40px',
                            justifyContent: lgdown ? 'none' : 'space-between',
                            width: lgdown ? '100%' : '50%',
                            gap: '20px',
                          }}
                        >
                          {/*
                            APIT-667: with targets off there is nothing to toggle between, so the
                            control is removed rather than defaulted or disabled. The wrapping Box
                            stays either way -- it is the left half of a space-between row whose
                            other child is Auto-Match, so dropping it as well would slide
                            Auto-Match across the toolbar. With targets on this renders exactly
                            what it always did.
                          */}
                          <Box>
                            {productivityTargetsEnabled && (
                              <Switcher
                                onChange={(option: any) => {
                                  setSwitchState(option);
                                }}
                                option1="Productivity Goal"
                                option2="PTIF"
                              />
                            )}
                          </Box>
                          <Box
                            display={'flex'}
                            alignItems={'center'}
                            sx={{
                              height: '30px',
                              width: '157px',
                              marginRight: '8px',
                            }}
                          >
                            <Button
                              onClick={() =>
                                dispatch(
                                  autoMatchingTherapistAction({
                                    providerId,
                                    discipline: currentTab ? currentTab : '',
                                    currentDate: selectedDate
                                      ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
                                      : '',
                                  })
                                )
                              }
                              disabled={
                                !(
                                  (therapistList as any)?.totalElements > 0 && isAutoMatchDisable
                                ) ||
                                !has(Permissions.CREATE_DAILY_TASK) ||
                                autoMatchingTherapistLoading
                              }
                              sx={{
                                fontFamily: 'Inter',
                                fontSize: '13px',
                                fontWeight: '600',
                                lineHeight: '18px',
                                letterSpacing: '0.2px',
                                borderRadius: '26px',
                                border:
                                  !(
                                    (therapistList as any)?.totalElements > 0 && isAutoMatchDisable
                                  ) || !has(Permissions.CREATE_DAILY_TASK)
                                    ? '1px solid #38425080'
                                    : '1px solid #6364F1',
                                padding: '4px 6px 4px 10px',
                                textWrap: 'nowrap',
                              }}
                            >
                              Assign automatically
                            </Button>
                          </Box>
                        </Box>
                      </Box>
                    </div>
                    <div
                      style={{
                        display:
                          (isLoadingTherapistList && showTherapistTaskMainLoader) ||
                          getAllMaintainedTherapists?.loading
                            ? 'flex'
                            : 'none',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '50vh',
                      }}
                    >
                      <img
                        src={LoaderIcon}
                        alt="my loader.."
                      />
                    </div>
                    {therapistListState?.length == 0 ? (
                      <Box
                        style={{
                          display:
                            (isLoadingTherapistList && showTherapistTaskMainLoader) ||
                            getAllMaintainedTherapists?.loading
                              ? 'none'
                              : 'inherit',
                        }}
                        margin={'10px'}
                      >
                        No therapist available
                      </Box>
                    ) : (
                      <>
                        <Grid
                          container
                          spacing={1.4}
                          sx={{
                            display:
                              isLoadingTherapistList && showTherapistTaskMainLoader
                                ? 'none'
                                : 'inherit',
                            height: 'auto',
                            p: 2,
                            maxHeight: '99%',
                            overflowY: 'scroll',
                            // scrollbarWidth: 'thin',
                          }}
                          onScroll={handleScroll}
                        >
                          {therapistListState &&
                            therapistListState.length > 0 &&
                            therapistListState?.map((therapist: any, index: number) => {
                              return (
                                <React.Fragment key={therapist?.uuid}>
                                  <Droppable
                                    key={therapist?.uuid}
                                    droppableId={therapist?.uuid}
                                  >
                                    {(provided) => (
                                      <Grid
                                        item
                                        {...provided.droppableProps}
                                        ref={(el) => {
                                          provided.innerRef(el);
                                        }}
                                        key={therapist?.uuid}
                                        data-testid={therapistColumnTestId(therapist?.uuid)}
                                        flex={1}
                                        sx={{
                                          borderRadius: '12px',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          minWidth: '380px',
                                          alignItems: 'start',
                                        }}
                                      >
                                        <TherapistInfo
                                          therapist={therapist}
                                          setIsStatsRefresh={setIsStatsRefresh}
                                          isStatsRefresh={isStatsRefresh}
                                          DeleteTherapistPatient={DeleteTherapistPatient}
                                          providerId={
                                            typeof providerId === 'string' ? providerId : ''
                                          }
                                          openEditTimeDialog={noOfTherapistEditDialogOpen}
                                          setOpenEditTimeDialog={setNoOfTherapistEditDialogOpen}
                                          index={index}
                                          date={selectedDate}
                                          updateDailyTasks={updateDailyTasks}
                                          readDailyTasks={readDailyTasks}
                                          // APIT-667: with no toggle to move it, the view is
                                          // pinned to PTIF. When targets are on this is
                                          // switchState verbatim.
                                          switchState={
                                            productivityTargetsEnabled ? switchState : 'PTIF'
                                          }
                                          productivityTargetsEnabled={productivityTargetsEnabled}
                                          handleOpenTaskNote={handleOpenTaskNote}
                                          setIsEditNote={setIsEditNote}
                                          setCurrentPatientTask={setCurrentPatientTask}
                                          editAssignedTaskMin={editAssignedTaskMin}
                                          therapistsList={therapistListState}
                                          selectedTaskType={selectedTaskType}
                                          currentTab={currentTab}
                                          currentSkillSelected={currentSkillSelected}
                                          selectedSortType={selectedSortType}
                                          searchData={searchData}
                                          filterTherapistList={filterTherapistList}
                                        />
                                        {provided.placeholder}
                                      </Grid>
                                    )}
                                  </Droppable>
                                </React.Fragment>
                              );
                            })}
                        </Grid>
                        {isLoadingTherapistList && !showTherapistTaskMainLoader && (
                          <Box
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              width: '100%',
                              top: '500px',
                              position: 'sticky',
                            }}
                          >
                            <img
                              src={LoaderIcon}
                              alt="loader.."
                            />
                          </Box>
                        )}
                      </>
                    )}
                  </Stack>
                </Stack>
              </DragDropContext>
            </Stack>
          </Stack>
        </Container>
      </Box>

      <BootstrapDialog
        onClose={handleCloseAddTaskForm}
        aria-labelledby="customized-dialog-title"
        open={openAddTaskForm}
      >
        <AddTaskForm
          date={selectedDate}
          currentTab={currentTab}
          selectedTaskType={selectedTaskType}
          handleCloseAddTaskForm={handleCloseAddTaskForm}
          patient={selectedPatientTask}
          source={createTaskSource}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleCloseInfo}
        aria-labelledby="customized-dialog-title"
        open={openModal}
      >
        <InfoModal
          close={handleCloseInfo}
          message={
            infoTitle === 'Reassign Individual Tasks Only'
              ? 'Group and concurrent tasks cannot be reassigned directly between therapists. Would you like to proceed with reassigning individual tasks ?'
              : infoTitle === 'Reassigning Group & Concurrent Tasks'
              ? 'Group and concurrent therapy assignments cannot be reassigned directly. To update the assignment, please cancel the current one and reassign it to the appropriate therapist.'
              : 'Open therapy planning screen ?'
          }
          title={infoTitle}
          gotIt={infoTitle === 'Reassigning Group & Concurrent Tasks'}
          button={{
            saveLabel: 'Confirm',
            closeLabel: 'Cancel',
          }}
          displayTime={false}
          handleSaveBtn={handleSaveBtn}
          testIds={confirmCancelTestIds('info-prompt')}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={openDialog && infoTitle === 'Unassign Individual Tasks Only'}
      >
        <InfoModal
          close={handleCloseDialog}
          message={
            'Group and concurrent tasks cannot be unassigned directly. Would you like to proceed with unassigning individual tasks ?'
          }
          title={infoTitle}
          gotIt={false}
          button={{
            saveLabel: 'Confirm',
            closeLabel: 'Cancel',
          }}
          displayTime={false}
          handleSaveBtn={handleUnassignConfirm}
          testIds={confirmCancelTestIds('unassign')}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleCloseDeleteModal}
        aria-labelledby="customized-dialog-title"
        open={deleteModalInfo.open || false}
      >
        <DeletePopupModal
          close={handleCloseDeleteModal}
          message={deleteModalInfo.message}
          button={{ saveLabel: deleteModalInfo.saveLabel, closeLabel: deleteModalInfo.closeLabel }}
          title={deleteModalInfo.title}
          handleSaveBtn={handleDeleteBtn}
          testIds={confirmCancelTestIds('delete')}
        />
      </BootstrapDialog>

      <Modal open={sucessFullRequest}>
        <SucessModal
          close={closeSuccessModal}
          title={successModalTitle.title}
          message={successModalTitle.message}
        />
      </Modal>

      <AppointmentSchedulingModal
        open={openAppointmentModal}
        onClose={handleCloseAppointmentModal}
        therapists={therapistListState}
        selectedTherapist={appointmentTherapist}
        patient={appointmentPatient}
        localDate={selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : ''}
        onScheduleAppointment={handleScheduleAppointment}
        providerId={typeof providerId === 'string' ? providerId : undefined}
        therapistsList={therapistListState}
        selectedSortType={selectedSortType}
        currentTab={currentTab}
        filterTherapistList={filterTherapistList}
        isDragDrop={appointmentPatient?.isOutPatient === true}
        migrateRecurring={migrateRecurring}
      />

      <BootstrapDialog
        onClose={() => setReSchedulingTask(false)}
        aria-labelledby="customized-dialog-title"
        open={reSchedulingTask}
      >
        <RescheduleTaskModal
          reSchedulingTaskDate={reSchedulingTaskDate}
          handleSelectDate={handleSelectDate}
          setReSchedulingTask={setReSchedulingTask}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleEditTimeDialog}
        aria-labelledby="customized-dialog-title"
        open={openEditTimeDialog}
      >
        <EditTaskTime
          providerId={typeof providerId === 'string' ? providerId : ''}
          handleEditTimeDialog={handleEditTimeDialog}
          therapyInfo={therapyInfo}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleCloseTaskNote}
        aria-labelledby="customized-dialog-title"
        open={isTaskNote}
      >
        <ScheduleTaskNote
          currentPatientTask={currentPatientTask}
          handleCloseTaskNote={handleCloseTaskNote}
          isEditNote={isEditNote}
          handleOpenDeleteTaskNote={handleOpenDeleteTaskNote}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={() => {
          setOpenGroupDialog(false);
          setCloseGroupDialog(true);
          setTaskSelectedId([]);
          setTherapistIdToDrop('');
          handleEditTime();
        }}
        aria-labelledby="customized-dialog-title"
        open={openGroupDialog}
      >
        <GroupTherapistTask
          assignGroupData={assignGroupData}
          setCloseGroupDialog={setCloseGroupDialog}
          setOpenGroupDialog={setOpenGroupDialog}
          providerId={typeof providerId === 'string' ? providerId : ''}
          selectedDate={selectedDate}
          therapistIdToDrop={therapistIdToDrop}
          setTaskSelectedId={setTaskSelectedId}
          meta={meta}
          isV2={true}
          assignTaskPage={assignTaskPage}
          currentTab={currentTab}
        />
      </BootstrapDialog>

      <BootstrapDialog
        PaperProps={{ style: { maxWidth: '600px' } }}
        onClose={() => setOpenAnnounceDialog(false)}
        aria-labelledby="customized-dialog-title"
        fullWidth
        open={openAnnounceDialog}
      >
        <AnnouncementDialog
          date={jsDate}
          handleCloseDialog={handlecloseAnnounceDialog}
          handleOpenDeleteAnnounceModal={handleOpenDeleteAnnounceModal}
        />
      </BootstrapDialog>

      <BootstrapDialog
        PaperProps={{ style: { maxWidth: '600px' } }}
        onClose={() => setOpenSplitMin(false)}
        aria-labelledby="customized-dialog-title"
        fullWidth
        open={openSplitMin}
      >
        <TaskSplitMin
          handleCancelSplitMin={() => setOpenSplitMin(false)}
          handleContinueSplitMin={handleContinueSplitMin}
          patient={splitMinPatient}
          sourceOfSplitMin={sourceOfSplitMin}
        />
      </BootstrapDialog>

      {popUpMessage.message && (
        <SimpleSnackbar
          message={popUpMessage.message}
          isError={popUpMessage.type === 'ERROR'}
          isWarning={popUpMessage.type === 'WARNING'}
          hideSuccessIcon={popUpMessage.hideSuccessIcon}
        />
      )}
      <BootstrapDialog
        onClose={handleInfoMessageClose}
        aria-labelledby="customized-dialog-title"
        open={!!infoMessage?.type}
      >
        <ConfirmationPopupModal
          close={handleInfoMessageClose}
          message={infoMessage?.message}
          title={infoMessage?.title}
          button={{
            saveLabel: 'Assign Anyway',
            closeLabel: 'Cancel',
          }}
          errorType="WARNING"
          handleSaveBtn={handleInfoMessageModal}
          testIds={confirmCancelTestIds('assign-warning')}
        />
      </BootstrapDialog>

      <BulkSchedulePrintDialog
        providerUUID={providerId}
        dateString={selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : ''}
        open={isBulkPrintOpen}
        onClose={() => setIsBulkPrintOpen(false)}
        scheduling={true}
        discipline={currentTab}
      />

      {showLoader && <Loader />}
    </>
  );
};

export default TherapistSchedule;
